/*
	historyManager sets up a listener to capture the hash changes in the URL 
	i.e. the tab hash is included in the URL and when the user navigates through the wizard, the hash changes.
	When the hash changes, the tab is clicked. 
	Also, if the user navigates back and forth, the tab is clicked. (browser back/forward buttons)
	This will also ensure that when the window is loaded, the state in the browser's history is blank and the first tab is selected.
*/
function historyManager() {

	const tabsComponent = document.querySelector('wizard-tabs-component');

	window.addEventListener('popstate', (e)=> {
		let currentHash = window.location.hash;	
		tabsComponent.querySelector(`.aTab[href="${currentHash}"]`).click();
	});

	window.addEventListener('load', function(e) {
		history.replaceState("", "", `${location.pathname}#food-planner-step-1`);
	});

}
historyManager();



/* 
	Wizard Tabs component. Responsible mainly for the tab switching functionality. 
	See: https://inclusive-components.design/tabbed-interfaces/
*/
class WizardTabsComponent extends HTMLElement {


	constructor() {
		super();
		this.tabbed = this; 
		this.tabBtnWrapper = this.tabbed.querySelector('ul.tablist');
		this.tablist = this.tabbed.querySelector('ul'); 
		this.tabs = this.tablist.querySelectorAll('a.aTab');
		this.panels = this.tabbed.querySelectorAll('[id^="food-planner-step"]'); 
		this.initTabs();
		this.addTabListeners();     
	}


	/*
		initTabs method initializes the tabs and panels, setting attributes and roles.
		This includes: 
			- adding role="tablist" to the tablist, role="tabpanel" to the panels,
			- setting aria-labelledby to the panels, (setting up ids for the tabs and panels)
			- selecting the first panel by setting aria-selected,
	*/
	initTabs() {
		this.tablist.setAttribute('role', 'tablist');

		Array.prototype.forEach.call(this.panels, (panel, i) => {
			panel.setAttribute('role', 'tabpanel');
			panel.setAttribute('tabindex', '-1');
			panel.setAttribute('aria-labelledby', `tab` + (i + 1));
			panel.hidden = true;                 
		});

		Array.prototype.forEach.call(this.tabs, (tab, i) => {
			tab.setAttribute('role', 'tab');
			tab.setAttribute('id', `tab` + (i + 1));
			tab.setAttribute('tabindex', '-1');
			tab.parentNode.setAttribute('role', 'presentation');   
		});

		if(this.tabs[0]) {
			this.tabs[0].removeAttribute('tabindex');
			this.tabs[0].setAttribute('aria-selected', 'true');
		}

		if(this.panels[0]) { this.panels[0].hidden = false }      
		//if (window.matchMedia('(max-width: 47.938em)').matches) { this.turnToAccordion() }

	}

	/*
		addTabListeners method adds event listeners to the tabs (click and keyboard).
		e.which === 37: left arrow key (key code 37)
		e.which === 39: right arrow key (key code 39)
		When a tab is clicked, the switchTab method is called.
		When a tab is focused and the left or right arrow key is pressed, the switchTab method is called.
	*/
	addTabListeners() {

		Array.prototype.forEach.call(this.tabs, (tab, i) => {

			tab.addEventListener('click', e => {
				//e.preventDefault();
				let currentTab = this.tablist.querySelector('[aria-selected]');
				if (e.currentTarget !== currentTab) {
					this.switchTab(currentTab, e.currentTarget);
				}
			});

			tab.addEventListener('keydown', e => {

				let index = Array.prototype.indexOf.call(this.tabs, e.currentTarget);
				let dir = e.which === 37 ? index - 1 : e.which === 39 ? index + 1 : null;

				if (dir !== null) {
					e.preventDefault();			
					let newIndex;
					if (this.tabs[dir]) { 
						newIndex = dir; 
					} else { 
						newIndex = dir === index - 1 ? this.tabs.length - 1 : 0; 
					}
					this.switchTab(e.currentTarget, this.tabs[newIndex]);
					this.tabs[newIndex].focus();
				}
			});

		});

	}  

	/*
		switchTab is responsible for switching the tab and the panel.
		It sets the new tab as focused, removes tabindex from the old tab, sets aria-selected to true for the new tab,
		removes aria-selected from the old tab, sets tabindex to -1 for the old tab,
		hides the old panel and shows the new panel.
	*/
	switchTab(oldTab, newTab) {
		newTab.focus();
		newTab.removeAttribute('tabindex');
		newTab.setAttribute('aria-selected', 'true');
		oldTab.removeAttribute('aria-selected');
		oldTab.setAttribute('tabindex', '-1');
		let index = Array.prototype.indexOf.call(this.tabs, newTab);
		let oldIndex = Array.prototype.indexOf.call(this.tabs, oldTab);
		this.panels[oldIndex].hidden = true;
		this.panels[index].hidden = false;
	}


}
customElements.define('wizard-tabs-component', WizardTabsComponent);
  


/*
	Found in Step 5, when the user has chosen the recipes, the treats section appears.
	It is responsible for switching between the treats panels.
	It is a simplified version of the WizardTabsComponent.

	FUTURE: 
		Can be refactored to use the WizardTabsComponent.
		This might cause some issues with the current implementation of the WizardTabsComponent.
		This is because there will be two instances of the same component nested in each other.
*/
class CollectionToggler extends HTMLElement {

	constructor() {
		super();
		this.buttons = this.querySelectorAll('.content-toggler');
		this.contents = this.querySelectorAll('.a-collection');
		this.addListeners();
	}

	addListeners() {
		this.buttons.forEach(btn => {
			btn.addEventListener('click', ()=> {
				
				let controlTarget = btn.getAttribute('aria-controls');
				this.contents.forEach(cnt => {
					
					this.buttons.forEach(btn => {
						btn.setAttribute('aria-expanded', false);
						cnt.classList.remove('flex');
						cnt.classList.add('none');
					})

					setTimeout(() => {
						if(cnt.id == controlTarget) {
							btn.setAttribute('aria-expanded', true);
							cnt.classList.remove('none');
							cnt.classList.add('flex');
						} 
					})

				})

			})
		})
	}



}
customElements.define('collection-toggler', CollectionToggler)



/*
	Found in Step 5, when the user has chosen recipes, the treats section appears.
	This is the treat product card. Each <product-card> carries the data a set of data-attributes.
	These include:
		- item_id
		- item_price
		- item_compareprice
		- item_policy
		- item_totalprice
		- item_totalqty
		- item_totalcompareprice (this might not be needed in the Planner, check if it can be removed)
		- item_variant_invqty
	These data attributed are initialized by product.selected_or_first_available_variant.xxxx in step 5
	and are updated accordingly when the user interacts with the card.
	
	Each card also includes:
		- a quantity input field, 
		- a plus and a minus button to increase or decrease the quantity,
		- a select field for the variants (if any)
*/
class ProductCard extends HTMLElement {
  

	constructor() {
		
		super();

		this.item_ID = Number(this.dataset.item_id)
		this.item_Price = Number(this.dataset.item_price); 	     
		this.item_TotalQTY = Number(this.dataset.item_totalqty);
		this.item_Policy = this.dataset.item_policy;
		this.item_TotalPrice = Number(this.dataset.item_totalprice);

		this.btn_plus = this.querySelector('input.plusQty');
		this.btn_minus = this.querySelector('input.minusQty');

		this.label_itemTotalQTY = this.querySelector('.label-item-total-qty'); 
		this.label_itemPricePerItem = this.querySelector('.label-price-per-item');

		this.variant_selects = this.querySelectorAll('.variant-select select');
		if(this.variant_selects.length !== 0) { this.listeners_variants() }

		this.listeners_quantity();
		
	}


	/*
		listeners_variants method adds event listeners to the variant select field.
		When a variant is selected, the card data is updated. 
		The data being updated come from the <option>s and include:
			- item_id (because each variant has own unique variant ID)
			- item_price (because each variant might have different price)
			- item_policy (because each variant might have selling policy)	
			- item_totalprice
			- item_totalqty

		Also, when the user selects a variant, the plus and minus buttons must be checked to see if they should be enabled or disabled.
		This can also affect the quantity of the item, in cases where the user first changes the quantity of the item, then selects a variant with a lower inventory quantity.
	*/
	listeners_variants() {
		this.variant_selects.forEach(select => {
			this.update_card_data(select);
			select.addEventListener('change', ()=> {			
				this.update_card_data(select);
				this.control_check_minusBtn(select)
				this.control_check_plusBtn(select)
			})

		})
	}


	/*
		listeners_quantity method adds event listeners to the plus and minus buttons.
		When the minus button / plus button is clicked, the quantity is adjusted.
		We need to verify if the plus and minus buttons should be enabled or disabled, depending on the variant quantity.
		The updated labels are the total quantity of the variant the user has selected.
		When the quantity is increased or decreased, the quantity is checked to see if it is more than the inventory quantity.
		If the quantity is more than the inventory quantity, the quantity is set to the inventory quantity. (so current max qty)
	*/
	listeners_quantity() {

		this.btn_minus.addEventListener('click', ()=> { 
			this.qty_decrease();       
			this.control_check_minusBtn();
			this.labels_update();
		})
		
		this.btn_plus.addEventListener('click', ()=> {             
			this.qty_increase(); 
			this.control_check_plusBtn();
			this.labels_update();
		})

	}


	/*
		update_card_data method updates the card data when a variant is selected.
		So each <option> within the select carries the data of the variant.
	*/
	update_card_data(select) {	

		this.current_selectedOption = select.options[ select.selectedIndex ];
		this.item_Price = this.current_selectedOption.dataset.variant_price;		
		this.dataset.item_id = this.current_selectedOption.value;	
		this.dataset.item_price = this.current_selectedOption.dataset.variant_price;
		this.dataset.item_policy = this.current_selectedOption.dataset.variant_policy;
		this.dataset.item_totalprice = `${ (this.item_TotalQTY * this.item_Price) }`;
		this.label_itemPricePerItem.textContent = `${this.current_selectedOption.dataset.variant_pricemoney}`;	
		this.setAttribute('data-item_variant_invqty', `${this.current_selectedOption.dataset.variant_invqty}`);
		this.querySelector('img').src = this.current_selectedOption.dataset.variant_img;
	}


	qty_increase() {
		this.item_TotalQTY = this.item_TotalQTY + 1   
		this.dataset.item_totalqty = `${this.item_TotalQTY}`;         
		this.dataset.item_totalprice = `${ (this.item_TotalQTY * this.item_Price) }`;
	}


	qty_decrease() {
		this.item_TotalQTY = this.item_TotalQTY - 1;
		this.dataset.item_totalqty = `${this.item_TotalQTY}`;         
		this.dataset.item_totalprice = `${ (this.item_TotalQTY * this.item_Price) }`;
	}


	labels_update() {  
		this.label_itemTotalQTY.textContent = `${this.item_TotalQTY}`;
	}


	/*
		control_check_minusBtn method CHECKS the quantity of the item.
		If the quantity is 0, the minus button is disabled.
		If the quantity is more than 0, the minus button is enabled.
		If the quantity is more than the inventory quantity, the quantity is set to the inventory quantity. (so current max qty)
	*/
	control_check_minusBtn(select) {

		if(this.item_TotalQTY > 0){

			this.control_toggle('enable', this.btn_minus)
		
			if(this.variant_selects.length !== 0) {

				if(this.item_TotalQTY < Number(this.dataset.item_variant_invqty)){			
					this.control_toggle('enable', this.btn_plus)
				} 
				
				if(this.item_TotalQTY == Number(this.dataset.item_variant_invqty)) {		
					this.control_toggle('disable', this.btn_plus)
				} 
				
				if(this.item_TotalQTY > Number(this.dataset.item_variant_invqty)){
					this.item_TotalQTY = Number(this.dataset.item_variant_invqty);
					this.dataset.item_totalqty = this.item_TotalQTY;					
					this.update_card_data(select)
					this.labels_update()
				}

			}

		} else {	
			this.control_toggle('disable', this.btn_minus)		
			this.control_toggle('enable', this.btn_plus)
		}
	}


	/*
		Similar to control_check_minusBtn, but for the plus button. There is an additional check for the item policy.
		If the item policy is 'deny' and the quantity reaches max qty, the plus button is disabled.
	*/
	control_check_plusBtn() {

		if(this.item_TotalQTY > 0) {

			this.control_toggle('enable', this.btn_minus);
			this.control_toggle('enable', this.btn_plus);

			if(this.item_Policy == 'deny') {

				if(this.variant_selects.length !== 0) {
					this.item_TotalQTY < Number(this.dataset.item_variant_invqty) ? 
						this.control_toggle('enable', this.btn_plus) : 
						this.control_toggle('disable', this.btn_plus);
				} else {
					this.item_TotalQTY < Number(this.dataset.item_product_invqty) ? 
						this.control_toggle('enable', this.btn_plus) : 
						this.control_toggle('disable', this.btn_plus);
				}

			} 

		} else {			
			this.control_toggle('disable', this.btn_minus)
			this.control_toggle('enable', this.btn_plus)
		}

	}


	control_toggle(state, element) {         
		state == 'disable' ? element.disabled = true : element.disabled = false;
	}

  
}
customElements.define('product-card', ProductCard)
  
  
  
/*
	This component wraps the <collection-toggler> and <product-card> components.
	It is responsible for capturing the total quantity and total price of the treats.
	This is achieved with a MutationObserver that 'listens' to the <product-card> components and their data-attributes.
	When a change in a <product-card> is detected, the total quantity and total price are updated.
*/
class ExtrasManager extends HTMLElement {


	constructor() {
		
		super();

		this.items = this.querySelectorAll('product-card.a-treat'); 
		this.total_extras = this.dataset.total_extras;
		this.total_extras_price = this.dataset.total_extras_price;
		this.label_extras_total = this.querySelector('.label_extras_total_price');

		this.totalQTY = 0;
		this.totalPrice = 0;

		this.add_mutation_observer();
		this.calculate_bulk_totals();
		//this.update_labels_itemsPerCollection();

	}
	

	/*
		This is where the main thing happens. add_mutation_observer method adds a MutationObserver to the ExtrasManager component
		and captures any change happening to <product-card> components. (These changes occur when the user interacts with the cards, selects variant, changes quantity, etc.)
		When a change in the data-attributes of a <product-card> is detected, the calculate_bulk_totals and update_labels_itemsPerCollection methods are called.
	*/
	add_mutation_observer() {
		let targetNodes = document.querySelectorAll('product-card.a-treat');          
		let options = { attributes: true };         
		let callback = (mutationList, observer) => {
			for (const mutation of mutationList) {
				if (mutation.type === 'attributes') {
					if(mutation.attributeName === "data-item_totalprice") {
						this.calculate_bulk_totals();
						this.update_labels_itemsPerCollection();
					}
			                
				}              
			}
		};

		let buldMutationObserver = new MutationObserver(callback);
		targetNodes.forEach((targetNode) => {
			buldMutationObserver.observe(targetNode, options);
		})
	}


	/*
		calculate_bulk_totals method calculates the total quantity and total price of the treats.
		These values are then set as data-attributes to the ExtrasManager component.
		This updates the EXTRAS TOTAL (.label_extras_total_price, eg: Σύνολο από extra: xx,xx € )
		This also updated the FINAL TOTAL text and data-attributes (.finalTotal, eg: Σύνολο: xx,xx € )
	*/
	calculate_bulk_totals() {

		this.totalQTY = 0;
		this.totalPrice = 0;

		this.items.forEach((item) => {

			this.totalQTY = this.totalQTY + Number(item.dataset.item_totalqty);
			this.setAttribute('data-total_extras', `${this.totalQTY}`);

			this.totalPrice = this.totalPrice + Number(item.dataset.item_totalprice); 
			this.setAttribute('data-total_extras_price', `${this.totalPrice}`); 
			
			document.querySelector('.finalTotal').setAttribute('data-extras_total', `${this.totalPrice}`)  
							
		});

		// setTimeout(() => {
			let recipe_total = Number(document.querySelector('.finalTotal').dataset.recipe_total);
			let extras_total = Number(document.querySelector('.finalTotal').dataset.extras_total);
			let total = (recipe_total + extras_total) / 100;
			document.querySelector('.finalTotal .label_combined_total').textContent = `${new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(total)}`;
			let temp_extras_total = extras_total / 100;
			document.querySelector('.label_extras_total_price').textContent = `${ new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(temp_extras_total)}`;					
		// }) 

		Number(this.dataset.total_extras_price) > 0 ? this.setAttribute('data-hasextras', 'true') : this.setAttribute('data-hasextras', 'false')

	}

	
	/*
		update_labels_itemsPerCollection method updates the labels (.label_itemsInSameCollection_total) of the <collection-toggler> component.
		These labels show the total quantity of items in that particular collection.
	*/
	update_labels_itemsPerCollection() {

		let labels = this.querySelectorAll('.label_itemsInSameCollection_total');
		if(labels.length !== 0) {
			labels.forEach(el => { el.remove() })
		}

		this.collections = this.querySelectorAll('.a-collection');
		this.collections.forEach(col => {

			let col_items = col.querySelectorAll('product-card');
			let itemsInSameCollection_total = 0;

			col_items.forEach(ci => {
				ci.classList.add(`in-${col.id}`);
				itemsInSameCollection_total = itemsInSameCollection_total + Number(ci.dataset.item_totalqty);
			})

			if(itemsInSameCollection_total > 0) {
				let col_button = this.querySelector(`button[aria-controls="${col.id}"]`);
				let label_itemsInSameCollection_total = document.createElement('span');
				label_itemsInSameCollection_total.style.marginRight = '1rem';
				label_itemsInSameCollection_total.classList.add('label_itemsInSameCollection_total');
				label_itemsInSameCollection_total.textContent = `(${itemsInSameCollection_total})`;
				col_button.insertBefore(label_itemsInSameCollection_total, col_button.querySelector('span'));
			}

		})

	}


}
customElements.define('extras-manager', ExtrasManager)
  
  

class FoodPlannerWizard extends HTMLElement {


	constructor() {

		super(); 

		/* 
			Global variables, you can find this in main-planner-new.liquid below the discount-debugger.
			It includes the recipes product data and the discount code.
		*/
		this.globalVariables = new GlobalPlannerVariables();

		// NEW: Store masterRecipeData
		this.recipeData = window.masterRecipeData || {}; 
		// console.log('Loaded this.recipeData:', JSON.parse(JSON.stringify(this.recipeData))); // For debugging

		this.healthIssuesArray = [];
		this.productIDsArray = [];
		this.allergiesArray = [];
		this.finalProduct = {};

		// this should contain final recipe prds + treats
		this.finalProductArray = [];

		this.recipePortions = {}; // NEW: To store portions for each recipe { 'recipe-handle': portions }
		this.totalRequiredPortions = 0; // NEW: To store total portions based on periodicity

		// New state variables for interactive recipe selection
		this.activeRecipeHandles = [];
		this.maxRecipesAllowed = 3;
		this.isManualMode = false;
		this.manualModeToggle = this.querySelector('#manualModeToggle');
		this.customPortionControls = this.querySelector('.custom-portion-controls');
		this.manualModeStatus = this.querySelector('#manualModeStatus');
		this.boundHandleRecipeCardClick = null; // Added for storing bound click handler

		this.portionDistributionMatrix = {
			"1": {
			  "1": {
				"Chicken": {"Chicken": 7},
				"Beef": {"Beef": 7},
				"Pork": {"Pork": 7},
				"Fish": {"Fish": 7},
				"Veggie": {"Veggie": 7}
			  },
			  "2": {
				"BeefChicken": {"Chicken": 4, "Beef": 3},
				"ChickenPork": {"Chicken": 4, "Pork": 3},
				"ChickenFish": {"Chicken": 4, "Fish": 3},
				"ChickenVeggie": {"Chicken": 4, "Veggie": 3},
				"BeefPork": {"Beef": 4, "Pork": 3},
				"BeefFish": {"Beef": 4, "Fish": 3},
				"BeefVeggie": {"Beef": 4, "Veggie": 3},
				"FishPork": {"Pork": 4, "Fish": 3},
				"PorkVeggie": {"Pork": 4, "Veggie": 3},
				"FishVeggie": {"Fish": 4, "Veggie": 3}
			  },
			  "3": {
				"BeefChickenPork": {"Chicken": 3, "Beef": 2, "Pork": 2},
				"BeefChickenFish": {"Chicken": 3, "Beef": 2, "Fish": 2},
				"BeefChickenVeggie": {"Chicken": 3, "Beef": 2, "Veggie": 2},
				"ChickenFishPork": {"Chicken": 3, "Pork": 2, "Fish": 2},
				"ChickenPorkVeggie": {"Chicken": 3, "Pork": 2, "Veggie": 2},
				"ChickenFishVeggie": {"Chicken": 3, "Fish": 2, "Veggie": 2},
				"BeefFishPork": {"Beef": 3, "Pork": 2, "Fish": 2},
				"BeefPorkVeggie": {"Beef": 3, "Pork": 2, "Veggie": 2},
				"BeefFishVeggie": {"Beef": 3, "Fish": 2, "Veggie": 2},
				"FishPorkVeggie": {"Pork": 3, "Fish": 2, "Veggie": 2}
			  },
			  "4": {
				"BeefChickenFishPork": {"Chicken": 2, "Beef": 2, "Pork": 2, "Fish": 1},
				"BeefChickenPorkVeggie": {"Chicken": 2, "Beef": 2, "Pork": 2, "Veggie": 1},
				"BeefChickenFishVeggie": {"Chicken": 2, "Beef": 2, "Fish": 2, "Veggie": 1},
				"ChickenFishPorkVeggie": {"Chicken": 2, "Pork": 2, "Fish": 2, "Veggie": 1},
				"BeefFishPorkVeggie": {"Beef": 2, "Pork": 2, "Fish": 2, "Veggie": 1}
			  }
			},
			"2": {
			  "1": {
				"Chicken": {"Chicken": 14},
				"Beef": {"Beef": 14},
				"Pork": {"Pork": 14},
				"Fish": {"Fish": 14},
				"Veggie": {"Veggie": 14}
			  },
			  "2": {
				"BeefChicken": {"Chicken": 7, "Beef": 7},
				"ChickenPork": {"Chicken": 7, "Pork": 7},
				"ChickenFish": {"Chicken": 7, "Fish": 7},
				"ChickenVeggie": {"Chicken": 7, "Veggie": 7},
				"BeefPork": {"Beef": 7, "Pork": 7},
				"BeefFish": {"Beef": 7, "Fish": 7},
				"BeefVeggie": {"Beef": 7, "Veggie": 7},
				"FishPork": {"Pork": 7, "Fish": 7},
				"PorkVeggie": {"Pork": 7, "Veggie": 7},
				"FishVeggie": {"Fish": 7, "Veggie": 7}
			  },
			  "3": {
				"BeefChickenPork": {"Chicken": 5, "Beef": 5, "Pork": 4},
				"BeefChickenFish": {"Chicken": 5, "Beef": 5, "Fish": 4},
				"BeefChickenVeggie": {"Chicken": 5, "Beef": 5, "Veggie": 4},
				"ChickenFishPork": {"Chicken": 5, "Pork": 5, "Fish": 4},
				"ChickenPorkVeggie": {"Chicken": 5, "Pork": 5, "Veggie": 4},
				"ChickenFishVeggie": {"Chicken": 5, "Fish": 5, "Veggie": 4},
				"BeefFishPork": {"Beef": 5, "Pork": 5, "Fish": 4},
				"BeefPorkVeggie": {"Beef": 5, "Pork": 5, "Veggie": 4},
				"BeefFishVeggie": {"Beef": 5, "Fish": 5, "Veggie": 4},
				"FishPorkVeggie": {"Pork": 5, "Fish": 5, "Veggie": 4} 
			  },
			  "4": {
				"BeefChickenFishPork": {"Chicken": 4, "Beef": 4, "Pork": 3, "Fish": 3},
				"BeefChickenPorkVeggie": {"Chicken": 4, "Beef": 4, "Pork": 3, "Veggie": 3},
				"BeefChickenFishVeggie": {"Chicken": 4, "Beef": 4, "Fish": 3, "Veggie": 3},
				"ChickenFishPorkVeggie": {"Chicken": 4, "Pork": 4, "Fish": 3, "Veggie": 3},
				"BeefFishPorkVeggie": {"Beef": 4, "Pork": 4, "Fish": 3, "Veggie": 3}
			  }
			},
			"4": {
			  "1": {
				"Chicken": {"Chicken": 28},
				"Beef": {"Beef": 28},
				"Pork": {"Pork": 28},
				"Fish": {"Fish": 28},
				"Veggie": {"Veggie": 28}
			  },
			  "2": {
				"BeefChicken": {"Chicken": 14, "Beef": 14},
				"ChickenPork": {"Chicken": 14, "Pork": 14},
				"ChickenFish": {"Chicken": 14, "Fish": 14},
				"ChickenVeggie": {"Chicken": 14, "Veggie": 14},
				"BeefPork": {"Beef": 14, "Pork": 14},
				"BeefFish": {"Beef": 14, "Fish": 14},
				"BeefVeggie": {"Beef": 14, "Veggie": 14},
				"FishPork": {"Pork": 14, "Fish": 14},
				"PorkVeggie": {"Pork": 14, "Veggie": 14},
				"FishVeggie": {"Fish": 14, "Veggie": 14}
			  },
			  "3": {
				"BeefChickenPork": {"Chicken": 10, "Beef": 10, "Pork": 8},
				"BeefChickenFish": {"Chicken": 10, "Beef": 10, "Fish": 8},
				"BeefChickenVeggie": {"Chicken": 10, "Beef": 10, "Veggie": 8},
				"ChickenFishPork": {"Chicken": 10, "Pork": 10, "Fish": 8},
				"ChickenPorkVeggie": {"Chicken": 10, "Pork": 10, "Veggie": 8},
				"ChickenFishVeggie": {"Chicken": 10, "Fish": 10, "Veggie": 8},
				"BeefFishPork": {"Beef": 10, "Pork": 10, "Fish": 8},
				"BeefPorkVeggie": {"Beef": 10, "Pork": 10, "Veggie": 8},
				"BeefFishVeggie": {"Beef": 10, "Fish": 10, "Veggie": 8},
				"PorkFishVeggie": {"Pork": 10, "Fish": 10, "Veggie": 8} // Corrected key based on user provided data, was PorkFishVeggie
			  },
			  "4": {
				"BeefChickenFishPork": {"Chicken": 8, "Beef": 8, "Pork": 6, "Fish": 6},
				"BeefChickenPorkVeggie": {"Chicken": 8, "Beef": 8, "Pork": 6, "Veggie": 6},
				"BeefChickenFishVeggie": {"Chicken": 8, "Beef": 8, "Fish": 6, "Veggie": 6},
				"ChickenFishPorkVeggie": {"Chicken": 8, "Pork": 8, "Fish": 6, "Veggie": 6},
				"BeefFishPorkVeggie": {"Beef": 8, "Pork": 8, "Fish": 6, "Veggie": 6}
			  }
			}
		  };

		// these come from the global variables
		// this.variantsArray = this.globalVariables.product_variants_capture; 
		// this.variantsArrayRenal = this.globalVariables.product_variants_renal_capture; 
		this.discount_code = this.globalVariables.discount_code;
			
		this.dog = [
            { _petType: 'DOG' },
			{ _name: '' }, 
			{ _gender: 'FEMALE' }, 
			{ _neutered: 'NO' }, 
			{ _adulthood: 'ADULT' },
			{ _age: null },         
			{ _weight: 10 }, 
			{ _grams_per_day: 300 },
			{ _breed: '' },
			{ _activity: 'LOW' }, 
			{ _bodytype: 'SLIM' }, 
			{ _allergies: 'NO' }, 
			{ _typeOfAllergies: [] }, 
			{ _extraAllergies: '' }, 
			{ _healthIssues: '' }, 
			{ _typeOfHealthIssues: [] }, 
			{ _recipes: [] },
			{ _periodicity: '4' },
			{ _typeOfPlan: 'SUBSCRIPTION' },
			{ _birthday_day: '' },
			{ _birthday_month: '' },
			{ _birthday_year: '' }
		];   
				
		this.breeds = [ 
			"Δεν είναι ράτσα, είναι φάτσα!", 
			"Affenpinscher", "Afghan Hound", "Africanis", "Aidi", "Airedale Terrier", "Akbash", "Akita", "Aksaray Malaklisi", "Alano Espanol", "Alapaha Blue Blood Bulldog", "Alaskan husky", "Alaskan Klee Kai", "Alaskan Malamute", "Alopekis", "Alpine Dachsbracke", "American Bulldog", "American bully", "American Cocker Spaniel", "American English Coonhound", "American Eskimo Dog", "American Foxhound", "American Hairless Terrier", "American Pit Bull Terrier", "American Staffordshire Terrier", "American Water Spaniel", "Andalusian Hound", "Anglo-Français de Petite Venerie", "Appenzeller Sennenhund", "Ariegeois", "Armant", "Armenian Gampr dog", "Artois Hound", "Australian Cattle Dog", "Australian Kelpie", "Australian Shepherd", "Australian Stumpy Tail Cattle Dog", "Australian Terrier", "Austrian Black and Tan Hound", "Austrian Pinscher", "Azawakh", 
			"Bakharwal dog", "Banjara Hound", "Barbado da Terceira", "Barbet", "Basenji", "Basque Shepherd Dog", "Basset Artesien Normand", "Basset Bleu de Gascogne", "Basset Fauve de Bretagne", "Basset Hound", "Bavarian Mountain Hound", "Beagle", "Beagle-Harrier", "Belgian Shepherd", "Bearded Collie", "Beauceron", "Bedlington Terrier", "Bergamasco Shepherd", "Berger Picard", "Bernese Mountain Dog", "Bichon Frise", "Billy", "Black and Tan Coonhound", "Black Norwegian Elkhound", "Black Russian Terrier", "Black Mouth Cur", "Bloodhound", "Blue Lacy", "Blue Picardy Spaniel", "Bluetick Coonhound", "Boerboel", "Bohemian Shepherd", "Bolognese", "Border Collie", "Border Terrier", "Borzoi", "Bosnian Coarse-haired Hound", "Boston Terrier", "Bouvier des Ardennes", "Bouvier des Flandres", "Boxer", "Boykin Spaniel", "Bracco Italiano", "Braque d'Auvergne", "Braque de l'Ariege", "Braque du Bourbonnais", "Braque Francais", "Braque Saint-Germain", "Briard", "Briquet Griffon Vendeen", "Brittany", "Broholmer", "Bruno Jura Hound", "Brussels Griffon", "Bucovina Shepherd Dog", "Bull Arab", "Bull Terrier", "Bulldog", "Bullmastiff", "Bully Kutta", "Burgos Pointer", "Buryat-Mongolian Wolfhound",
			"Ca Me Mallorqui", "Cairn Terrier", "Campeiro Bulldog", "Can de Chira", "Can de Palleiro", "Canaan Dog", "Canadian Eskimo Dog", "Cane Corso", "Cane di Oropa", "Cane Paratore", "Cantabrian Water Dog", "Cao da Serra de Aires", "Cao de Castro Laboreiro", "Cao de Gado Transmontano", "Cao Fila de Sao Miguel", "Cardigan Welsh Corgi", "Carea Castellano Manchego", "Carea Leones", "Carolina Dog", "Carpathian Shepherd Dog", "Catahoula Leopard Dog", "Catalan Sheepdog", "Caucasian Shepherd Dog", "Cavalier King Charles Spaniel", "Central Asian Shepherd Dog", "Cesky Fousek", "Cesky Terrier", "Chesapeake Bay Retriever", "Chien Francais Blanc et Noir", "Chien Francais Blanc et Orange", "Chien Francais Tricolore", "Chihuahua", "Chilean Terrier", "Chinese Crested Dog", "Chinook", "Chippiparai", "Chongqing dog", "Chortai", "Chow Chow", "Chukotka sled dog", "Cimarron Uruguayo", "Cirneco dell'Etna", "Clumber Spaniel", "Colombian fino hound", "Continental bulldog", "Coton de Tulear", "Cretan Hound", "Croatian Sheepdog", "Curly-Coated Retriever", "Cursinu", "Czechoslovakian Wolfdog", 
			"Dachshund", "Dalmatian", "Dandie Dinmont Terrier", "Danish Spitz", "Danish-Swedish Farmdog", "Denmark Feist", "Dingo", "Dobermann", "Dogo Argentino", "Dogo Guatemalteco", "Dogo Sardesco", "Dogue Brasileiro", "Dogue de Bordeaux", "Drentse Patrijshond", "Drever", "Dunker", "Dutch Shepherd", "Dutch Smoushond", 
			"East Siberian Laika", "East European Shepherd", "Ecuadorian Hairless Dog", "English Cocker Spaniel", "English Foxhound", "English Mastiff", "English Setter", "English Shepherd", "English Springer Spaniel", "English Toy Terrier (Black & Tan)", "Entlebucher Mountain Dog", "Estonian Hound", "Estrela Mountain Dog", "Eurasier", 
			"Field Spaniel", "Fila Brasileiro", "Finnish Hound", "Finnish Lapphund", "Finnish Spitz", "Flat-Coated Retriever", "French Bulldog", "French Spaniel", 
			"Galgo Espanol", "Garafian Shepherd", "Gascon Saintongeois", "Georgian Shepherd", "German Hound", "German Longhaired Pointer", "German Pinscher", "German Roughhaired Pointer", "German Shepherd", "German Shorthaired Pointer", "German Spaniel", "German Spitz", "German Wirehaired Pointer", "Giant Schnauzer", "Glen of Imaal Terrier", "Golden Retriever", "Gończy Polski", "Gordon Setter", "Grand Anglo-Français Blanc et Noir", "Grand Anglo-Français Blanc et Orange", "Grand Anglo-Français Tricolore", "Grand Basset Griffon Vendeen", "Grand Bleu de Gascogne", "Grand Griffon Vendeen", "Great Dane", "Greater Swiss Mountain Dog", "Greek Harehound", "Greek Shepherd", "Greenland Dog", "Greyhound", "Griffon Bleu de Gascogne", "Griffon Fauve de Bretagne", "Griffon Nivernais", "Gull Dong", "Gull Terrier", 
			"Hällefors Elkhound", "Halden Hound", "Hamiltonstövare", "Hanover Hound", "Harrier", "Havanese", "Himalayan Sheepdog", "Hierran Wolfdog", "Hokkaido", "Hovawart", "Huntaway", "Hygen Hound", 
			"Ibizan Hound", "Icelandic Sheepdog", "Indian pariah dog", "Indian Spitz", "Irish Red and White Setter", "Irish Setter", "Irish Terrier", "Irish Water Spaniel", "Irish Wolfhound", "Istrian Coarse-haired Hound", "Istrian Shorthaired Hound", 
			"Italian Greyhound", 
			"Jack Russell Terrier", "Jagdterrier", "Japanese Chin", "Japanese Spitz", "Japanese Terrier", "Jindo", "Jonangi", 
			"Kai Ken", "Kaikadi", "Kangal Shepherd Dog", "Kanni", "Karakachan dog", "Karelian Bear Dog", "Kars", "Karst Shepherd", "Keeshond", "Kerry Beagle", "Kerry Blue Terrier", "Khala", "King Charles Spaniel", "King Shepherd", "Kintamani", "Kishu", "Kokoni", "Kombai", "Komondor", "Kooikerhondje", "Koolie", "Koyun dog", "Kromfohrländer", "Kuchi", "Kuvasz", 
			"Labrador Retriever", "Lagotto Romagnolo", "Lakeland Terrier", "Lancashire Heeler", "Landseer", "Lapponian Herder", "Large Münsterländer", "Leonberger", "Levriero Sardo", "Lhasa Apso", "Liangshan Dog", "Lithuanian Hound", "Löwchen", "Lupo Italiano", 
			"Mackenzie River husky", "Magyar agar", "Mahratta Greyhound", "Maltese", "Manchester Terrier", "Maneto", "Maremmano-Abruzzese Sheepdog", "McNab dog", "Miniature American Shepherd", "Miniature Bull Terrier", "Miniature Fox Terrier", "Miniature Pinscher", "Miniature Schnauzer", "Molossus of Epirus", "Montenegrin Mountain Hound", "Mountain Cur", "Mountain Feist", "Mucuchies", "Mudhol Hound", "Mudi", 
			"Neapolitan Mastiff", "Nenets Herding Laika", "New Guinea singing dog", "New Zealand Heading Dog", "Newfoundland", "Norfolk Terrier", "Norrbottenspets", "Northern Inuit Dog", "Norwegian Buhund", "Norwegian Elkhound", "Norwegian Lundehund", "Norwich Terrier", "Nova Scotia Duck Tolling Retriever", 
			"Old Croatian Sighthound", "Old Danish Pointer", "Old English Sheepdog", "Old English Terrier", "Olde English Bulldogge", "Otterhound", 
			"Pachon Navarro", "Pampas Deerhound", "Papillon", "Parson Russell Terrier", "Pastore della Lessinia e del Lagorai", "Patagonian Sheepdog", "Patterdale Terrier", "Pekingese", "Pembroke Welsh Corgi", "Perro Majorero", "Perro de Pastor Mallorquin", "Perro de Presa Canario", "Perro de Presa Mallorquin", "Peruvian Inca Orchid", "Petit Basset Griffon Vendeen", "Petit Bleu de Gascogne", "Phalène", "Pharaoh Hound", "Phu Quoc Ridgeback", "Picardy Spaniel", "Plummer Terrier", "Plott Hound", "Podenco Canario", "Podenco Valenciano", "Pointer", "Poitevin", "Polish Greyhound", "Polish Hound", "Polish Lowland Sheepdog", "Polish Tatra Sheepdog", "Pomeranian", "Pont-Audemer Spaniel", "Poodle", "Porcelaine", "Portuguese Podengo", "Portuguese Pointer", "Portuguese Water Dog", "Posavac Hound", "Pražský Krysařik", "Pshdar dog", "Pudelpointer", "Pug", "Puli", "Pumi", "Pungsan dog", "Pyrenean Mastiff", "Pyrenean Mountain Dog", "Pyrenean Sheepdog", 
			"Rafeiro do Alentejo", "Rajapalayam", "Rampur Greyhound", "Rat Terrier", "Ratonero Bodeguero Andaluz", "Ratonero Mallorquin", "Ratonero Murciano", "Ratonero Valenciano", "Redbone Coonhound", "Rhodesian Ridgeback", "Romanian Mioritic Shepherd Dog", "Romanian Raven Shepherd Dog", "Rottweiler", "Rough Collie", "Russian Spaniel", "Russian Toy", "Russo-European Laika", "Ryukyu Inu", 
			"Saarloos Wolfdog", "Sabueso Espanol", "Saint Bernard", "Saint Hubert Jura Hound", "Saint-Usuge Spaniel", "Saluki", "Samoyed", "Sapsali", "Sarabi dog", "Sardinian Shepherd Dog", "Sarplaninac", "Schapendoes", "Schillerstovare", "Schipperke", "Schweizer Laufhund", "Schweizerischer Niederlaufhund", "Scottish Deerhound", "Scottish Terrier", "Sealyham Terrier", "Segugio dell Appennino", "Segugio Italiano", "Segugio Maremmano", "Serbian Hound", "Serbian Tricolour Hound", "Serrano Bulldog", "Shar Pei", "Shetland Sheepdog", "Shiba Inu", "Shih Tzu", "Shikoku", "Shiloh Shepherd", "Siberian Husky", "Silken Windhound", "Silky Terrier", "Sinhala Hound", "Skye Terrier", "Sloughi", "Slovakian Wirehaired Pointer", "Slovensky Cuvac", "Slovensky Kopov", "Smalandstovare", "Small Greek domestic dog", "Small Munsterlander", "Smooth Collie", "Smooth Fox Terrier", "Soft-Coated Wheaten Terrier", "South Russian Ovcharka", "Spanish Mastiff", "Spanish Water Dog", "Spinone Italiano", "Sporting Lucas Terrier", "Stabyhoun", "Staffordshire Bull Terrier", "Standard Schnauzer", "Stephens Stock", "Styrian Coarse-haired Hound", "Sussex Spaniel", "Swedish Elkhound", "Swedish Lapphund", "Swedish Vallhund", "Swedish White Elkhound", 
			"Taigan", "Taiwan Dog", "Tamaskan Dog", "Tang Dog", "Tazy", "Teddy Roosevelt Terrier", "Telomian", "Tenterfield Terrier", "Terrier Brasileiro", "Thai Bangkaew Dog", "Thai Ridgeback", "Tibetan Kyi Apso", "Tibetan Mastiff", "Tibetan Spaniel", "Tibetan Terrier", "Tonya Finosu", "Torkuz", "Tornjak", "Tosa", "Toy Fox Terrier", "Toy Manchester Terrier", "Transylvanian Hound", "Treeing Cur", "Treeing Feist", "Treeing Tennessee Brindle", "Treeing Walker Coonhound", "Trigg Hound", "Tyrolean Hound", 
			"Vikhan", "Villano de Las Encartaciones", "Villanuco de Las Encartaciones", "Vizsla", "Volpino Italiano", 
			"Weimaraner", "Welsh Sheepdog", "Welsh Springer Spaniel", "Welsh Terrier", "West Country Harrier", "West Highland White Terrier", "West Siberian Laika", "Westphalian Dachsbracke", "Wetterhoun", "Whippet", "White Shepherd", "White Swiss Shepherd Dog", "Wire Fox Terrier", "Wirehaired Pointing Griffon", "Wirehaired Vizsla", "Xiasi Dog", "Xoloitzcuintle", "Yakutian Laika", "Yorkshire Terrier", "Zerdava"
		];

		this.breedList = this.querySelector('#breedList');
		
		// FIELDS
		this.form 		        = this.querySelector('.mealPlannerForm');
		this.dogNameField       = this.querySelector('[name="DOG_NAME"]');
		this.dogGenderFields    = this.querySelectorAll('[name="DOG_GENDER"]');
		this.dogNeuteredFields  = this.querySelectorAll('[name="DOG_NEUTERED"]');
		
		this.dogAdulthoodFields = this.querySelectorAll('[name="DOG_ADULTHOOD"]');
		this.dogBirthday_day    = this.querySelector('[name="DOG_BIRTHDAY_DAY"]');
		this.dogBirthday_month  = this.querySelector('[name="DOG_BIRTHDAY_MONTH"]');

		this.dogWeightField     = this.querySelector('[name="DOG_WEIGHT"]');  
		this.dogBreedField	    = this.querySelector('[name="DOG_BREED"]');
		this.dogActivityFields  = this.querySelectorAll('[name="DOG_ACTIVITY"]');    
		this.dogBodytypeFields  = this.querySelectorAll('[name="DOG_BODYTYPE"]');
		this.dogAllergiesDeciderFields    = this.querySelectorAll('[name="DOG_ALLERGIES_DECIDER"]');            
		this.dogHealthIssuesDeciderFields = this.querySelectorAll('[name="DOG_HEALTH_ISSUES_DECIDER"]');       

		// AGE 
		this.dogPuppyAgeWrapper = this.querySelector('.dogAgeMonths');
		this.dogAdultAgeWrapper = this.querySelector('.dogAgeYears');
		this.dogPuppyAgeFields  = this.dogPuppyAgeWrapper.querySelector('[name="DOG_AGE_MONTHS"]');   
		this.dogAdultAgeFields  = this.dogAdultAgeWrapper.querySelector('[name="DOG_AGE_YEARS"]');
		this.ageSelects         = [this.dogPuppyAgeFields, this.dogAdultAgeFields];

		// ALLERGIES GROUP
		this.dogAllergiesWrapper      = this.querySelector('.dogAllergies'); 
		this.dogAllergiesFields       = this.dogAllergiesWrapper.querySelectorAll('[name="DOG_ALLERGIES"]');        
		this.dogExtraAllergiesWrapper = this.querySelector('.dogExtraAllergies');    
		this.allergiesText            = '';        
		this.extraAllergiesField      = this.querySelector('[name="EXTRA_ALLERGIES_TEXT"]');      
		this.dogHealthIssuesWrapper   = this.querySelector('.dogHealthIssues'); 
		this.dogHealthIssuesFields    = this.dogHealthIssuesWrapper.querySelectorAll('[name="DOG_HEALTH_ISSUES"]');     

		// STEP FIELDS GROUPED PER STEP
		this.step1Fields = [this.dogNameField, ...this.dogGenderFields, ...this.dogNeuteredFields]; 
		this.step2Fields = [...this.dogAdulthoodFields, ...this.ageSelects];
		this.step3Fields = [this.dogWeightField, this.dogBreedField, ...this.dogActivityFields, ...this.dogBodytypeFields];  
		this.step4Fields = [...this.dogAllergiesDeciderFields, ...this.dogAllergiesFields, this.extraAllergiesField, ...this.dogHealthIssuesDeciderFields, ...this.dogHealthIssuesFields];

		// NEXT PAGE BTNS
		this.goto2 = this.querySelector('.goto_step2');
		this.goto3 = this.querySelector('.goto_step3');
		this.goto4 = this.querySelector('.goto_step4');
		this.goto5 = this.querySelector('.goto_step5');

		// TAB LIST ITEMS
		this.litab2 = this.querySelector('#tab-li-2');
		this.litab3 = this.querySelector('#tab-li-3');
		this.litab4 = this.querySelector('#tab-li-4');
		this.litab5 = this.querySelector('#tab-li-5');

		// VARIOUS LABELS THROUGHOUT THE MEAL PLANNER
		this.labels_Name = this.querySelectorAll('.label_name'); 
		this.labels_Days = this.querySelectorAll('.label_days'); 
		this.labels_Price = this.querySelectorAll('.label_price');                
		this.labels_Gender = this.querySelectorAll('.label_gender');
		this.labels_Gender2 = this.querySelectorAll('.label_gender_alt');               
		this.label_ageAdult = this.querySelector('.label_ageAdult');
		this.label_agePuppy = this.querySelector('.label_agePuppy');          
		this.labels_Adulthood = this.querySelectorAll('.label_adulthood');
		this.labels_Periodicity = this.querySelectorAll('.label_periodicity');
		this.labels_week = this.querySelectorAll('.label_week');
		this.labels_weeks = this.querySelectorAll('.label_weeks');
		this.labels_GramsPerDay = this.querySelectorAll('.label_gramsperday');
		this.labels_Price_per_day = this.querySelectorAll('.label_price_per_day');

		// FINAL COMBINED TOTAL
		this.final_total_wrapper = this.querySelector('.finalTotal');
		//this.recipe_total = this.final_total_wrapper.dataset.recipe_total;
		//this.extras_total = this.final_total_wrapper.dataset.extras_total;
		this.label_combined_total = this.final_total_wrapper.querySelector('.label_combined_total');    

		// LIVE REGIONS      
		this.activityRegionTemplate = this.querySelector('#activityRegionTemplate');
		this.liveRegionTemplate = this.querySelector('#liveRegionTemplate');

		// PANELS, THESE ARE ALL FOUND IN STEP 5
		this.loaderPanel  = this.querySelector('.loaderPanel');
		this.errorPanel   = this.querySelector('.errorPanel');
		this.abortPanel   = this.querySelector('.abortPanel');
		this.prefacePanel = this.querySelector('.prefacePanel'); 

		this.preCheckoutPanel = this.querySelector('.preCheckoutPanel')
		this.checkoutPanel    = this.querySelector('.checkoutPanel');

		this.unavailablePanel = this.querySelector('.unavailablePanel');
		this.periodicityPanel = this.querySelector('.periodicityPanel');
		this.planTypePanel    = this.querySelector('.plantypePanel');

		// PRODUCT PANELS, FOUND IN STEP 5
		this.productsPanel = this.querySelector('.products-panel');    

		// PRODUCTS
		this.products = this.querySelectorAll('.a-product'); // Will iterate over these to find controls
		this.matchedProduct;    

		// FLAGS
		this.abortFlag = false;
		this.unavailableFlag = false;
		this.reached5flag = false;
		
		// PLAN TYPE, UNDER RECIPES, STEP 5
		this.planTypeFields = this.querySelectorAll('[name="TYPE_OF_PLAN"]');
		this.planTypeValue = 'SUBSCRIPTION';
		this.planTypeDescription_s = this.querySelector('.plantypeDescription-subscription');
		this.planTypeDescription_o = this.querySelector('.plantypeDescription-onetime');

		// PERIODICITY, UNDER PLAN TYPE, STEP 5
		this.periodicityFields = this.querySelectorAll('[name="PERIODICITY"]');           
		this.periodicityValue = '4';	
		this.periodicityDays = 28;   

		// ADD TO CART BUTTON
		this.atc = this.checkoutPanel.querySelector('.atcBtn');

		// RUN
		this.disableFormSubmission();
		//this.cart_clear(); // clears cart on load

		// LISTENERS FOR FIELDS IN EACH STEP
		this.listeners_Step1(); 
		this.listeners_Step2(); 
		this.listeners_Step3(); 
		this.listeners_Step4(); 
		this.listeners_Step5();

		// This is used for puppies but i cant remember why we did it this way. Most probably there is a better way.
		// DO NOT DELETE, these are used in grams_per_day_puppy()		
		this.kilogroup_1  = [ [0], [1,2], [3], [4], [5, 6], [7,8], [9,10,11], [12,13,14,15], [16,17,18,19,20], [21, 22], [] ];
		this.kilogroup_2  = [ [0], [1,2], [3], [4], [5, 6], [7,8], [9,10,11], [12,13,14,15], [16,17,18,19,20], [21, 22] ];
		this.kilogroup_3  = [ [0], [1,2], [3], [4], [5, 6], [7,8], [9,10,11], [12,13,14,15], [16,17,18,19,20], [21, 22] ];
		this.kilogroup_4  = [ [0], [1,2], [3], [4,5], [6,7], [8,9], [10,11,12,13], [14,15,16,17,18], [19,20,21,22,23], [24,25,26,27,28,29,30,31,32] ]
		this.kilogroup_5  = [ [0], [1,2], [3], [4,5], [6,7,8], [9,10], [11,12,13,14], [15,16,17,18], [19,20,21,22,23,24], [25,26,27,28,29,30,31,32] ]
		this.kilogroup_6  = [ [0], [1,2], [3,4], [5,6], [7,8], [9,10], [11,12,13,14], [15,16,17,18,19,20], [21,22,23,24,25,26], [27,28,29,30,31,32,33,34,35,36,37,38,39,40] ]
		this.kilogroup_7  = [ [0], [1,2], [3,4], [5,6], [7,8], [9,10,11], [12,13,14,15], [16,17,18,19,20,21], [22,23,24,25,26,27], [28,29,30,31,32,33,34,35,36,37,38,39,40] ]
		this.kilogroup_8  = [ [0], [1,2], [3,4], [5,6], [7,8,9], [10,11,12], [13,14,15,16], [17,18,19,20,21,22], [23,24,25,26,27,28], [29,30,31,32,33,34,35,36,37,38,39,40] ]
		this.kilogroup_9  = [ [0], [1,2], [3,4], [5,6], [7,8,9], [10,11,12], [13,14,15,16,17], [18,19,20,21,22,23], [24,25,26,27,28,29,30], [31,32,33,34,35,36,37,38,39,40] ]
		this.kilogroup_10 = [ [0], [1,2], [3,4,5], [6,7], [8,9,10], [11,12,13], [14,15,16,17,18], [19,20,21,22,23,24,25], [26,27,28,29,30,31,32], [33,34,35,36,37,38,39,40] ]
		this.kilogroup_11 = [ [0], [1,2,3], [4,5], [6,7,8], [9,10,11], [12,13,14], [15,16,17,18,19], [20,21,22,23,24,25,26], [27,28,29,30,31,32,33,34], [35,36,37,38,39,40] ]
		this.kilogroup_12 = [ [0], [1,2,3], [4,5,6], [7,8,9], [10,11,12], [13,14,15,16], [17,18,19,20,21,22], [23,24,25,26,27,28,29], [30,31,32,33,34,35,36,37], [38,39,40,41,42,43,44,45,46,47,48,49] ]
			
		// ...
		this.fixed_grams = [0, 125, 200, 300, 400, 500, 600, 800, 1000, 1200]

		//console.log('wizard-v5.6 - added bday field');

	}


	/* ==========================================
	=== Read / Write helper methods =============  
	=== to main array (main array = this.dog) === 
	========================================== */  
	data_write(key, value) {     
		this.dog.forEach((entry, index) => {          
			for (const property in entry) {           
				if(property === key) {
					entry[key] = value;
					// Enable this when debugging
					// console.log(entry, index, this.dog);
				}
			}
		});
	}

	data_read(keys = Array) {
		let temp = []
		keys.forEach((key) => {      
			this.dog.forEach((entry) => { 
			for (const property in entry) {
				if(property === key) {
					// Enable this when debugging
					// console.log(entry[key]);
					temp.push(entry[key]);
				}
			}       
			})
		});	
		return temp;
	}


	/* ==================================
	=== Event listeners for each step === 
	================================== */ 
	/*
		Note that each field has a callback function that is called when the field is changed / interacted with.
		The callback is also called on load, in cases where the field is pre-filled. (Firefox)
	*/
	listeners_Step1() {

		// Name input 	
		window.addEventListener("load", () => { this.callback_name_input(this.dogNameField); });  	         
		this.dogNameField.addEventListener('keyup', e => { this.callback_name_input(this.dogNameField); });
		this.dogNameField.addEventListener('blur', e => { this.callback_name_input(this.dogNameField); }); 

		// Gender inputs
		this.dogGenderFields.forEach((genderField) => { 
			window.addEventListener("load", () => { this.callback_gender_radios(genderField); });         
			genderField.addEventListener('change', ()=> { this.callback_gender_radios(genderField); });
		});

		// Neutered inputs
		this.dogNeuteredFields.forEach((neuterField) => {
			window.addEventListener("load", () => { this.callback_neutered_radios(neuterField); });  
			neuterField.addEventListener('change', ()=> { this.callback_neutered_radios(neuterField); });  
		});

		// Next page btn 
		this.goto2.addEventListener('click', (e) => {                           
			this.validation_stepFields(this.step1Fields, this.goto2) == true ? (         
				this.labels_write({ name : this.data_read(['_name']), gender : this.data_read(['_gender']) }),          
				this.validation_toggleTab(true, [this.litab2]),
				this.goto_page(this.litab2.querySelector('a'))
			) : ( 
				this.validation_toggleTab(false, [this.litab2, this.litab3, this.litab4, this.litab5]) 
			)
		});
		
		this.labels_write({ name : this.data_read(['_name']), gender : this.data_read(['_gender']) });
		
	}

	listeners_Step2() {

		// Adulthood inputs    
		this.dogAdulthoodFields.forEach((adulthoodField) => { 
			window.addEventListener("load", () => { this.callback_adulthood_radios(adulthoodField); });  
			adulthoodField.addEventListener('change', (e)=> { this.callback_adulthood_radios(adulthoodField); });
		});

		// Age selectors
		this.ageSelects.forEach((ageSelect) => { 
			window.addEventListener("load", () => { this.callback_age_selects(ageSelect); });
			ageSelect.addEventListener('change', (e) => { this.callback_age_selects(ageSelect); });      
		});

		// Birthday (day) input
		window.addEventListener("load", () => { this.callback_birthday_day(this.dogBirthday_day); });  
		this.dogBirthday_day.addEventListener('change', (e)=> { this.callback_birthday_day(this.dogBirthday_day); });

		// Birthday (month) input
		window.addEventListener("load", () => { this.callback_birthday_month(this.dogBirthday_month); });  
		this.dogBirthday_month.addEventListener('change', (e)=> { this.callback_birthday_month(this.dogBirthday_month); });

		// Next page btn
		this.goto3.addEventListener('click', (e) => {                
			this.validation_stepFields(this.step2Fields, this.goto3) == true ? (
				this.validation_toggleTab(true, [this.litab3]),
				this.goto_page(this.litab3.querySelector('a'))                    
			) : this.validation_toggleTab(false, [this.litab3, this.litab4, this.litab5])                   
		});    

	}

	listeners_Step3() {

		// Weight select
		window.addEventListener("load", () => { this.callback_weight_select(this.dogWeightField) });
		this.dogWeightField.addEventListener('change', ()=> { 
			this.callback_weight_select(this.dogWeightField);                 
		}); 

		// Breed input
		this.dogBreedField ? (
			this.createBreedOptions(), 
			this.dogBreedField.addEventListener('keyup', (e) => { this.callback_breed_input(this.dogBreedField) }), 
			this.dogBreedField.addEventListener('blur', (e) => { this.callback_breed_input(this.dogBreedField) }) 
		) : null;

		// Activity fields
		this.dogActivityFields.forEach((activityField) => {
			window.addEventListener("load", () => { this.callback_activity_radios(activityField) });
			activityField.addEventListener('change', () => { 
				this.callback_activity_radios(activityField);       
			});
		});  

		// Bodytype fields
		this.dogBodytypeFields.forEach((bodytypeField) => {
			window.addEventListener("load", () => { this.callback_type_radios(bodytypeField) });
			bodytypeField.addEventListener('change', () => {  
				this.callback_type_radios(bodytypeField);
			});
		});

		// Next page btn 
		this.goto4.addEventListener('click', (e) => {   
			this.validation_stepFields(this.step3Fields, this.goto4) == true ? (
				this.validation_toggleTab(true, [this.litab4]),
				this.goto_page(this.litab4.querySelector('a')) 
			) : this.validation_toggleTab(false, [this.litab4, this.litab5]);
		});

	}

	listeners_Step4() {

		// Allergies (yes/no)
		this.dogAllergiesDeciderFields.forEach((allergyChoice) => {
			window.addEventListener("load", () => { this.callback_allergies_decider_radios(allergyChoice); });  
			allergyChoice.addEventListener('change', ()=> { 
				this.callback_allergies_decider_radios(allergyChoice);
			});
		});  

		// Allergies checkboxes
		this.dogAllergiesFields.forEach((allergyField) => {
			window.addEventListener("load", () => { this.callback_allergies_checkboxes(allergyField); }); 
			allergyField.addEventListener('change', (e) => { 
				this.callback_allergies_checkboxes(allergyField, e);
			});
		});

		// Extra allergies textarea
		window.addEventListener("load", () => { this.callback_extrallergies_textarea(this.extraAllergiesField); }); 
		this.extraAllergiesField.addEventListener('blur', ()=> { this.callback_extrallergies_textarea(this.extraAllergiesField); });   
		this.extraAllergiesField.addEventListener('keyup', ()=> { this.callback_extrallergies_textarea(this.extraAllergiesField); });

		// Health issues inputs (yes/no)	
		this.dogHealthIssuesDeciderFields.forEach((healthIssueChoice) => {
			window.addEventListener("load", () => { this.callback_healthissues_decider_radios(healthIssueChoice); });
			healthIssueChoice.addEventListener('change', ()=> { this.callback_healthissues_decider_radios(healthIssueChoice); });
		}); 

		// Health issues checkboxes
		this.dogHealthIssuesFields.forEach((healthIssue) => {
			window.addEventListener("load", () => { this.callback_issues_checkboxes(healthIssue); });
			healthIssue.addEventListener('change', (e) => { this.callback_issues_checkboxes(healthIssue, e); });
		}); 

		// Next page btn 
		/* 
			Note that only in this step, panels_set_step5 runs. 
			It is responsible for setting the panels in step 5.
			Read more in the method itself.
		*/
		this.goto5.addEventListener('click', (e) => {      
			if (this.validation_stepFields(this.step4Fields, this.goto5) == true) {
				this.validation_toggleTab(true, [this.litab5]);
				this.goto_page(this.litab5.querySelector('a'));
				this.initializeStep5View();
				// this.labels_write() // labels_write is called within initializeStep5View
			} else {
				this.validation_toggleTab(false, [this.litab5]);
			}         
		});

	}  

	listeners_Step5() {
			
		// Fixed pricing panel
		this.fixed_pricing_panel_IO();

		// NEW: Recipe Quantity Control Listeners
		this.products.forEach(productCard => {
			const productHandle = productCard.querySelector('.recipe-portion-input').dataset.productHandle;
			const portionInput = productCard.querySelector('.recipe-portion-input');
			const portionDisplay = productCard.querySelector('.recipe-portion-display'); // Get the span
			const minusButton = productCard.querySelector('.button--minus');
			const plusButton = productCard.querySelector('.button--plus');
			
			// Initialize portions for this recipe if not already set
			if (!this.recipePortions[productHandle]) {
				this.recipePortions[productHandle] = 0;
			}

			portionInput.addEventListener('change', (event) => {
				let newValue = parseInt(event.target.value, 10);
				const oldValue = this.recipePortions[productHandle] || 0;
				if (isNaN(newValue) || newValue < 0) newValue = 0;

				let otherPortionsTotal = 0;
				for (const handle in this.recipePortions) {
					if (handle !== productHandle) {
						otherPortionsTotal += this.recipePortions[handle] || 0;
					}
				}

				if (newValue + otherPortionsTotal > this.totalRequiredPortions) {
					newValue = Math.max(0, this.totalRequiredPortions - otherPortionsTotal);
					event.target.value = newValue;
					console.log("Input adjusted to not exceed max total portions.");
				}

				const changeInPortions = newValue - oldValue;

				this.updatePortionAndPrice(productHandle, newValue); // Update current recipe first

				// Attempt redistribution if portions were decreased AND total is now below required
				if (changeInPortions < 0) { // Portions were decreased for this recipe
					let currentTotalSelectedPortions = 0;
					for (const handle in this.recipePortions) { // this.recipePortions already updated by updatePortionAndPrice
						currentTotalSelectedPortions += this.recipePortions[handle] || 0;
					}

					if (currentTotalSelectedPortions < this.totalRequiredPortions) {
						const deficit = this.totalRequiredPortions - currentTotalSelectedPortions;
						const visibleRecipeInputs = Array.from(this.querySelectorAll('.a-product:not(.none) .recipe-portion-input'));
						const otherVisibleRecipes = visibleRecipeInputs.filter(input => input.dataset.productHandle !== productHandle);

						if (otherVisibleRecipes.length > 0) {
							// Simple strategy: add to the first *other* visible recipe
							const targetRecipeInput = otherVisibleRecipes[0];
							const targetProductHandle = targetRecipeInput.dataset.productHandle;
							const targetCurrentPortions = this.recipePortions[targetProductHandle] || 0;
							const portionsToAdd = Math.min(deficit, Math.abs(changeInPortions)); // Add back up to what was removed, or what's needed
                            
                            // Ensure we don't try to add more than the original deficit to this one recipe if other recipes could also take some
                            // For a simple one-to-one transfer, portionsToAdd is fine. If deficit is larger than what was removed,
                            // it implies other recipes were also below their share, but this simple logic focuses on the direct reduction.

							const newTargetPortions = targetCurrentPortions + portionsToAdd;
							targetRecipeInput.value = newTargetPortions;
							this.updatePortionAndPrice(targetProductHandle, newTargetPortions); 
							// No need to call calculateAndUpdateOverallTotal here, updatePortionAndPrice does it.
						} else {
                            // No other recipe to redistribute to, total will remain below required.
                            // calculateAndUpdateOverallTotal will be called by the initial updatePortionAndPrice.
                        }
					} else {
                        // Total is already at or above required, no redistribution needed, or capping already handled it.
                        // calculateAndUpdateOverallTotal will be called by the initial updatePortionAndPrice.
                    }
				}
			});
			portionInput.addEventListener('input', (event) => { // For immediate feedback while typing
				let newValue = parseInt(event.target.value, 10);
				if (isNaN(newValue) || newValue < 0) newValue = 0;
				// This provides instant price updates but validation against total will be tricky here
				// For now, stick to 'change' for the main logic, or add debouncing if using 'input'
				this.updatePortionAndPrice(productHandle, newValue, true); // Pass a flag for preview
			});

			minusButton.addEventListener('click', () => {
				if (this.isManualMode) {
					let currentValue = parseInt(portionInput.value, 10);
					if (isNaN(currentValue) || currentValue <= 0) return; // Can't go below 0
		
					const newValue = currentValue - 1;
					portionInput.value = newValue;
					if (portionDisplay) portionDisplay.textContent = newValue;
		
					this.updatePortionAndPrice(productHandle, newValue);
					this.checkManualTotalAndToggleATC();
					return;
				}

				let currentValue = parseInt(portionInput.value, 10);
				if (isNaN(currentValue)) currentValue = 0;

				if (currentValue === 0) { // Already at minimum, do nothing
					return;
				}

				let proposedNewValue = currentValue - 1; // This will be >= 0 because currentValue > 0

				// NEW CHECK FOR SINGLE ACTIVE RECIPE: Prevent going below totalRequiredPortions
				if (this.activeRecipeHandles.length === 1 && this.activeRecipeHandles[0] === productHandle) {
					if (proposedNewValue < this.totalRequiredPortions) {
						console.log(`Single active recipe (${productHandle}). Minus click would drop portions to ${proposedNewValue}, which is below total required (${this.totalRequiredPortions}). Preventing decrease.`);
						return; 
					}
				}
				
				// If we reach here, the decrease is allowed.
				const newValue = proposedNewValue; 
				
				portionInput.value = newValue;
				if (portionDisplay) portionDisplay.textContent = newValue; // Update span for clicked item immediately

				this.updatePortionAndPrice(productHandle, newValue); // Update current recipe and its price

				// Attempt redistribution only if there are multiple active recipes
				if (this.activeRecipeHandles.length > 1) {
					let currentTotalSelectedPortionsAfterDecrease = 0;
					for (const handle in this.recipePortions) { // this.recipePortions is updated by updatePortionAndPrice
						currentTotalSelectedPortionsAfterDecrease += this.recipePortions[handle] || 0;
					}

					if (currentTotalSelectedPortionsAfterDecrease < this.totalRequiredPortions) {
						const deficit = this.totalRequiredPortions - currentTotalSelectedPortionsAfterDecrease;
						const visibleRecipeInputs = Array.from(this.querySelectorAll('.a-product:not(.none) .recipe-portion-input'));
						
						// Filter for other *active* and visible recipes to give portions to
						const otherVisibleAndActiveRecipeInputs = visibleRecipeInputs.filter(input => {
							const otherHandle = input.dataset.productHandle;
							return otherHandle !== productHandle && this.activeRecipeHandles.includes(otherHandle);
						});

						if (otherVisibleAndActiveRecipeInputs.length > 0) {
							const targetRecipeInput = otherVisibleAndActiveRecipeInputs[0]; // Give to the first one
							const targetProductHandle = targetRecipeInput.dataset.productHandle;
							const targetCurrentPortions = this.recipePortions[targetProductHandle] || 0;
							
							// Add back 1 portion (what was removed), but not exceeding the total deficit
							const portionsToAdd = Math.min(1, deficit); 
							const newTargetPortions = targetCurrentPortions + portionsToAdd;

							targetRecipeInput.value = newTargetPortions;
							const targetPortionDisplay = targetRecipeInput.closest('.a-product').querySelector('.recipe-portion-display');
							if (targetPortionDisplay) targetPortionDisplay.textContent = newTargetPortions;

							this.updatePortionAndPrice(targetProductHandle, newTargetPortions);
						}
					}
				}
                // calculateAndUpdateOverallTotal is called by updatePortionAndPrice for all cases.
			});

			plusButton.addEventListener('click', () => {
				if (this.isManualMode) {
					let currentValue = parseInt(portionInput.value, 10);
					if (isNaN(currentValue)) currentValue = 0;
					
					const newValue = currentValue + 1;
					portionInput.value = newValue;
					if (portionDisplay) portionDisplay.textContent = newValue;
					
					this.updatePortionAndPrice(productHandle, newValue);
					this.checkManualTotalAndToggleATC();
					return;
				}

				let currentValue = parseInt(portionInput.value, 10);
				if (isNaN(currentValue)) currentValue = 0;

				let currentTotalSelectedPortions = 0;
				for (const handle in this.recipePortions) {
					currentTotalSelectedPortions += this.recipePortions[handle] || 0;
				}

				if (currentTotalSelectedPortions < this.totalRequiredPortions) {
					// Space to add one more portion without exceeding total
					const newValue = currentValue + 1;
					portionInput.value = newValue;
					this.updatePortionAndPrice(productHandle, newValue);
				} else { // currentTotalSelectedPortions >= this.totalRequiredPortions
					// Try to "steal" a portion from another recipe
					const visibleRecipeInputs = Array.from(this.querySelectorAll('.a-product:not(.none) .recipe-portion-input'));
					const otherVisibleRecipeInputs = visibleRecipeInputs.filter(input => input.dataset.productHandle !== productHandle);
					
					let victimFoundAndProcessed = false;
					for (const victimInput of otherVisibleRecipeInputs) {
						const victimProductHandle = victimInput.dataset.productHandle;
						const victimCurrentPortions = this.recipePortions[victimProductHandle] || 0;

						if (victimCurrentPortions > 0) {
							// Found a victim with portions to steal
							const newVictimPortions = victimCurrentPortions - 1;
							victimInput.value = newVictimPortions;
							const victimDisplay = victimInput.closest('.recipe-quantity-controls').querySelector('.recipe-portion-display');
							if (victimDisplay) victimDisplay.textContent = newVictimPortions; // Update victim's span
							this.updatePortionAndPrice(victimProductHandle, newVictimPortions); // Update victim

							// Now increment the clicked recipe
							const newValueForClicked = currentValue + 1;
							
							portionInput.value = newValueForClicked;
							if (portionDisplay) portionDisplay.textContent = newValueForClicked; // Update clicked recipe's span
							this.updatePortionAndPrice(productHandle, newValueForClicked); // Update clicked

							victimFoundAndProcessed = true;
							break; // Stop searching for victims
						}
					}

					if (!victimFoundAndProcessed) {
						console.log("Max total portions reached, and no other recipe has portions to redistribute.");
						// Optional: Provide UI feedback that the action can't be completed.
					}
				}
			});
		});

		// Product details (<details>)
		document.addEventListener('mouseup', (e) => {
			this.callback_product_details(e);
		});

		// Plan type fields
		this.planTypeFields.forEach((planTypeField) => {
			window.addEventListener("load", () => { this.callback_plantype_radios(planTypeField) });
			planTypeField.addEventListener('change', ()=> { this.callback_plantype_radios(planTypeField);         
			});                                  
		});

		// Periodicity fields
		this.periodicityFields.forEach((periodicityField) => {
			window.addEventListener("load", () => { this.callback_periodicity_radios(periodicityField) });
			periodicityField.addEventListener('change', ()=> {  
				this.callback_periodicity_radios(periodicityField); 
			});
		});

		// ATC button
		this.atc.addEventListener('click', () => {

			(async () => {        
				this.product_CreateFinalProduct(this.matchedProduct, this.data_read(['_recipes']), this.data_read(['_name']));    
				let addResult = await this.cart_addItems();          
				// let attributes = this.cart_DataToObject();      
				// let setAttributes = await this.cart_setAttributes(attributes);  

				if (addResult.status === 200 || addResult.status === 201) { // Shopify often returns 200 on /cart/add.json
					// location.href = `/checkout${this.discount_code}`
					// Add delay before redirect to allow cart state to sync on server
					setTimeout(() => {
						location.href = `/cart`;
					}, 500);
				} else {         
					// Error panel is likely already toggled by cart_addItems if it failed due to empty cart or API error.
                    // This ensures it's shown if cart_addItems had an issue not covered by its direct panel toggling.
					if (!this.errorPanel.classList.contains('flex')) {
                         this.panels_toggle([
                            [this.errorPanel, true], [this.abortPanel, false], [this.prefacePanel, false], [this.periodicityPanel, false], [this.preCheckoutPanel, false],
                            [this.productsPanel, false], [this.unavailablePanel, false], [this.checkoutPanel, false], [this.loaderPanel, false]
                        ]);
                    }
                    console.error("Failed to add items to cart. Status:", addResult.status, "Message:", addResult.error_message, "Full Response:", addResult.response_body);
				} 	
			})();  

		})    

	}


	/* ====================
	=== Input Callbacks === 
	==================== */

	// ~~~ step 1 ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

	callback_name_input(input) {
		this.data_write('_name', input.value)       
		input.value == '' ? ( 
			this.validation_toggleStyle(false, input.closest('.fieldWrapper')),
			this.validation_toggleTab(false, [this.litab2, this.litab3, this.litab4, this.litab5]),
			this.validation_toggleStepBtn(false, this.goto2)
		) : ( 
			this.validation_toggleStyle(true, input.closest('.fieldWrapper')),
			this.validation_toggleStepBtn(true, this.goto2)
		) 
	}

	callback_gender_radios(radio) {
		if(radio.checked == true) {
			this.data_write('_gender', radio.value),         
			this.validation_toggleTab(false, [this.litab2, this.litab3, this.litab4, this.litab5])
		}
	}

	callback_neutered_radios(radio) {
		if(radio.checked == true) {
			this.data_write('_neutered', radio.value);      
			radio.value == 'YES' ? this.data_write('_activity', 'STERILE') : ( 
				this.dogActivityFields.forEach((activityField) => { 
					activityField.checked == true ? this.data_write('_activity', activityField.value) : null 
				})
			);        
			this.validation_toggleTab(false, [this.litab2, this.litab3, this.litab4, this.litab5])
		}     
	}

  	// ~~~ step 2 ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

	callback_adulthood_radios(radio) {
		if(radio.checked == true) {

			this.data_write('_birthday_year', '');
			this.data_write('_birthday_month', '');
			this.dogBirthday_month.selectedIndex = 0;

			this.data_write('_adulthood', radio.value);         
			this.age_toggleSelectors(radio); 
			this.age_resetSelector(radio); 
			this.validation_toggleTab(false, [this.litab3, this.litab4, this.litab5]); 
			
			if(this.validation_stepFields(this.step2Fields, this.goto3) == true) {
				this.validation_toggleStepBtn(true, this.goto3)
			} else {
				this.validation_toggleTab(false, [this.litab3, this.litab4, this.litab5])
			}

		}     
	}

	callback_birthday_day(select) {		
		this.data_write('_birthday_day', select.value)
	}

	callback_birthday_month(select) {
		let selectedOption = null;
		for (var i = 0; i < select.options.length; i++) {
			if (select.options[i].value === select.value) {
				selectedOption = select.options[i];
				break;
			}
		}
		this.data_write('_birthday_month', `${select.value} (${selectedOption.textContent})`)
	}
  
	callback_age_selects(select) {
		if(select.value != '') {

			this.data_write('_age', select.value);
			this.data_write('_birthday_month', '');

			let selectedValue = Number(select.value);
			let currentYear = new Date().getFullYear();
			let currentMonth = new Date().getMonth() + 1; // Adding 1 to make it 1-indexed
			// Enable this when debugging
			// console.log('currentYear', currentYear, 'currentMonth', currentMonth)

			if(select == this.dogAdultAgeFields) {

				this.data_write('_birthday_year', `${currentYear - selectedValue}`);

			} else {

				let birthYear, birthMonth, temp_month;
				let remainingMonths = selectedValue - currentMonth;
				// console.log('remainingMonths', remainingMonths)
			
				if (remainingMonths >= 0) {
					// If remainingMonths is positive or zero, the birth year is the current year minus 1
					// and the birth month must count from 12 minus remainingMonths
					birthYear = currentYear - 1;
					birthMonth = 12 - remainingMonths;
				} else {
					// If remainingMonths is negative, the birth year is the current year
					// and the birth month is the absolute value of remainingMonths
					birthYear = currentYear;
					birthMonth = currentMonth + remainingMonths;
				}

				for (let i = 0; i < this.dogBirthday_month.options.length; i++) {
					if (Number(this.dogBirthday_month.options[i].value) === birthMonth) {
						temp_month = this.dogBirthday_month.options[i].textContent;
						this.dogBirthday_month.options[i].selected = true;
						break;
					}
				}

				this.data_write('_birthday_year', `${birthYear}`);
				this.data_write('_birthday_month', `${birthMonth} (${temp_month})`);

			}

			//this.data_write('_ageGroup', select.selectedOptions[0].dataset.agegroup);  
			this.labels_write({ age : select.value });
			this.validation_toggleTab(false, [this.litab3, this.litab4, this.litab5]); 

			this.validation_stepFields(this.step2Fields, this.goto3) == true ? 
				this.validation_toggleStepBtn(true, this.goto3) : 
				this.validation_toggleTab(false, [this.litab3, this.litab4, this.litab5]);
			
		}
	}

  	// ~~~ step 3 ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
  
	callback_weight_select(select) {

		if(select.value != '') {
			this.data_write('_weight', Number(select.value));

			// ok?
			if(this.data_read(['_adulthood']) == 'PUPPY') {
				this.data_write('_grams_per_day', this.grams_per_day_puppy() );          
			} else {  
				this.data_write('_grams_per_day', Number(select.selectedOptions[0].dataset.grperday) );
			}
			
			this.labels_write({ grams : select.value});
			this.validation_toggleTab(false, [this.litab4, this.litab5])

			if(this.validation_stepFields(this.step3Fields, this.goto4) == true) {
				this.validation_toggleStepBtn(true, this.goto4)
			} else {
				this.validation_toggleTab(false, [this.litab4, this.litab5])
			}

			//this.validation_stepFields(this.step3Fields, this.goto4) == true ? this.validation_toggleStepBtn(true, this.goto4) : this.validation_toggleTab(false, [this.litab4, this.litab5]) 
		}  

	}

	callback_breed_input(input) {
		this.data_write('_breed', input.value) 
		if(input.value == '') {
			this.data_write('_breed', 'UNKNOWN') 
		}
	}
  
	callback_activity_radios(radio) {
		if(radio.checked == true) {       
			this.data_read(['_neutered']) == 'YES' ? this.data_write('_activity', 'STERILE') : this.data_write('_activity', radio.value);                          
			this.a11y_updateActivityRegion(radio.dataset.desc); 
			this.validation_toggleTab(false, [this.litab4, this.litab5])

			if(this.validation_stepFields(this.step3Fields, this.goto4) == true) {
				this.validation_toggleStepBtn(true, this.goto4)
			} else {
				this.validation_toggleTab(false, [this.litab4, this.litab5])
			}	
		}
	}

	callback_type_radios(radio) {
		if(radio.checked == true) {

			if(this.data_read(['_neutered']) == 'YES') {
				this.data_write('_activity', 'STERILE')
			} else {
				if(radio.value == 'OBESE') { this.data_write('_activity', 'LOW') }
			}

			//this.data_read(['_neutered']) == 'YES' ? this.data_write('_activity', 'STERILE') : radio.value == 'OBESE' ? this.data_write('_activity', 'LOW') : null;

			this.data_write('_bodytype', radio.value); 
			this.validation_toggleTab(false, [this.litab4, this.litab5])

			if(this.validation_stepFields(this.step3Fields, this.goto4) == true) {
				this.validation_toggleStepBtn(true, this.goto4)
			} else {
				this.validation_toggleTab(false, [this.litab4, this.litab5])
			}

			//this.validation_stepFields(this.step3Fields, this.goto4) == true ? this.validation_toggleStepBtn(true, this.goto4) : this.validation_toggleTab(false, [this.litab4, this.litab5])  
		}    
	}

  	// ~~~ step 4 ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

	callback_allergies_decider_radios(radio) {
		if(radio.checked == true) {      
			this.data_write('_allergies', radio.value); 

			radio.value == 'NO' ? ( this.allergies_reset(), this.allergies_toggleAllergiesPanel(false) ) : this.allergies_toggleAllergiesPanel(true), 

			this.validation_stepFields(this.step4Fields, this.goto5) == true ? ( 
				this.data_write('_allergies', radio.value), 
				this.validation_toggleStepBtn(true, this.goto5),
				this.validation_toggleTab(false, [this.litab5])
			) : (
				this.validation_toggleStepBtn(false, this.goto5),
				this.validation_toggleTab(false, [this.litab5])
			)
		}
	}

	callback_allergies_checkboxes(checkbox, event) {
		checkbox.value == 'EXTRA_ALLERGY' ? (  
			checkbox.checked == true ? ( this.allergies_toggleAllergiesTextarea(true) ) : ( this.allergies_toggleAllergiesTextarea(false), this.data_write('_extraAllergies', ''), this.extraAllergiesField.value = '' )   
		) : (            
			checkbox.checked == true ? ( this.allergiesArray.push(checkbox.value), this.data_write('_typeOfAllergies', this.allergiesArray) ) : ( 
				this.allergiesArray = this.allergiesArray.filter(item => item !== checkbox.value), this.data_write('_typeOfAllergies', this.allergiesArray) 
			)           
		)  

		if(event != undefined) {
			this.toggleCheckBoxRequired(this.dogAllergiesFields);     
			
			// If we're already on step 5, update the filtering immediately
			if (this.querySelector('#food-planner-step-5').style.display !== 'none') {
				this.applyRecipeFilters();
				this.renderRecipeCardsState();
			}
			
			this.validation_stepFields(this.step4Fields, this.goto5) == true ? (
				this.validation_toggleStepBtn(true, this.goto5), this.validation_toggleTab(false, [this.litab5])
			) : (
				this.validation_toggleStepBtn(false, this.goto5), this.validation_toggleTab(false, [this.litab5])
			)
		}
	}

	callback_extrallergies_textarea(textarea) {
		this.allergiesText = textarea.value; 
		textarea.value == '' ? ( 
			this.data_write('_extraAllergies', ''), this.validation_toggleStyle(false, textarea)
		) : ( 
			this.data_write('_extraAllergies', textarea.value), this.validation_toggleStyle(true, textarea) 
		); 

		this.validation_stepFields(this.step4Fields, this.goto5) == true ? (
			this.validation_toggleStepBtn(true, this.goto5), this.validation_toggleTab(false, [this.litab5])
		) : (
			this.validation_toggleStepBtn(false, this.goto5), this.validation_toggleTab(false, [this.litab5])
		)
	}
  
	callback_healthissues_decider_radios(radio) {    
		if(radio.checked == true) {
			this.data_write('_healthIssues', radio.value);       
			radio.value == 'NO' ? ( this.healthIssues_reset(), this.healthIssues_toggleIssuesPanel(false) ) : this.healthIssues_toggleIssuesPanel(true),

			this.validation_stepFields(this.step4Fields, this.goto5) == true ? (
				this.validation_toggleStepBtn(true, this.goto5), this.validation_toggleTab(false, [this.litab5])
			) : (
				this.validation_toggleStepBtn(false, this.goto5), this.validation_toggleTab(false, [this.litab5])
			)   
		}  
	}

	callback_issues_checkboxes(checkbox, event) {
		checkbox.checked == true ? ( 
			this.healthIssuesArray.push(checkbox.value), 
			this.data_write('_typeOfHealthIssues', this.healthIssuesArray)                           
		) : ( 
			this.healthIssuesArray = this.healthIssuesArray.filter(item => item !== checkbox.value), 
			this.data_write('_typeOfHealthIssues', this.healthIssuesArray) 
		) 

		//this.atLeastOneAbortChecked = (el) => el.value == 'ABORT' && el.checked;
		//[...this.dogHealthIssuesFields].some(this.atLeastOneAbortChecked) == true ? this.abortFlag = true : this.abortFlag = false  

		if(event != undefined) {
			this.toggleCheckBoxRequired(this.dogHealthIssuesFields); 
			
			// If we're already on step 5, update the filtering immediately
			if (this.querySelector('#food-planner-step-5').style.display !== 'none') {
				this.applyRecipeFilters();
				this.renderRecipeCardsState();
			}
			
			this.validation_stepFields(this.step4Fields, this.goto5) == true ? ( 
				this.validation_toggleStepBtn(true, this.goto5), this.validation_toggleTab(false, [this.litab5])
			) : ( 
				this.validation_toggleStepBtn(false, this.goto5), this.validation_toggleTab(false, [this.litab5]) 
			)
		}   
	}      

  	// ~~~ step 5 ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

	callback_product_checkboxes(checkbox) {

        checkbox.checked == true ? (			
            this.currentCheckedPrdCnt += 1,                  
            this.recipesArray.push(checkbox.value), 
            this.data_write('_recipes', this.recipesArray) 
        ) : (           
            this.currentCheckedPrdCnt -= 1,    
            this.currentCheckedPrdCnt < 0 ? this.currentCheckedPrdCnt = 0 : null,                               
            this.recipesArray = this.recipesArray.filter(item => item !== checkbox.value), 
            this.data_write('_recipes', this.recipesArray) 
        ); 

		// if there is at least one selected recipe, then show the other panels, otherwise hide them
		// The user can't proceed to precheckout(treats)/checkout without selecting at least one recipe, 
		if(this.currentCheckedPrdCnt > 0) {
			this.panels_toggle([ [this.preCheckoutPanel, true],  [this.checkoutPanel, true] ]);
		} else {
			this.panels_toggle([ [this.preCheckoutPanel, false], [this.checkoutPanel, false] ])
		}

	}

  	callback_product_details(e) {
		this.querySelectorAll('.a-product details').forEach(prd => {
			if (!prd.contains(e.target)) {
				prd.open = false;
			}
		});    
	}
  
	/*
		Note the call to products_filterIDS. Each periodicity value corresponds to a different variant.
		Reminder: the variants are stored in main-planner-new.liquid, in GlobalPlannerVariables (this.product_variants_capture)
	*/
	products_filterIDS(periodicityField) {

		// Check if the source arrays are populated, if not, return empty array.
		// Fallback to use the globalVariables directly if they exist, otherwise assign empty arrays to avoid undefined errors.
		const variantsArrayToUse = this.globalVariables && this.globalVariables.product_variants_capture ? this.globalVariables.product_variants_capture : [];
		const variantsArrayRenalToUse = this.globalVariables && this.globalVariables.product_variants_renal_capture ? this.globalVariables.product_variants_renal_capture : [];
		const variantsArrayHepaticToUse = this.globalVariables && this.globalVariables.product_variants_hepatic_capture ? this.globalVariables.product_variants_hepatic_capture : [];

		if (variantsArrayToUse.length === 0 && variantsArrayRenalToUse.length === 0 && variantsArrayHepaticToUse.length === 0) {
			console.warn('products_filterIDS: product_variants_capture, product_variants_renal_capture and product_variants_hepatic_capture are empty or not initialized. This function may be deprecated or the data source is missing.');
			// return []; // If we absolutely must return an empty array when no variants are found
		}

		const healthIssuesForFilter = this.data_read(['_typeOfHealthIssues'])[0];
		if (Array.isArray(healthIssuesForFilter) && healthIssuesForFilter.includes('HEALTH_ISSUE_KIDNEY')) {
			console.log('renal', true);
			var filtered = variantsArrayRenalToUse.filter(entry => entry[0] == `${periodicityField.dataset.match}` && entry[2] == this.data_read(['_grams_per_day']) );
		} else if (Array.isArray(healthIssuesForFilter) && healthIssuesForFilter.includes('HEALTH_ISSUE_LIVER_DISEASE')) {
			console.log('hepatic', true);
			var filtered = variantsArrayHepaticToUse.filter(entry => entry[0] == `${periodicityField.dataset.match}` && entry[2] == this.data_read(['_grams_per_day']) );
		} else {
			console.log('renal/hepatic', false);
			var filtered = variantsArrayToUse.filter(entry => entry[0] == `${periodicityField.dataset.match}` && entry[2] == this.data_read(['_grams_per_day']) );
		}
		return filtered;

	}

	product_CreateFinalProduct(matchedProduct, recipes, name) {

		let attributes = this.cart_DataToObject();

		// recipe
		var temp;
		var matched_variant_id = matchedProduct[0][1];
		var matched_plan_id = matchedProduct[0][5]; 
		
		/*
			This is where the object that will be sent to Cart API is created.
			Required: id, quantity
			The check for language is done for Checkout.

			Note that that the ELSE statement of: if(planTypeField.checked == true && planTypeField.value == 'ONE_TIME')
			also contains the selling_plan:matched_plan_id. matchedProduct[0][5]
			This is because the selling_plan is required for subscriptions.
		*/
		this.planTypeFields.forEach((planTypeField) => {
			if(planTypeField.checked == true && planTypeField.value == 'ONE_TIME') {
				if (document.documentElement.lang == 'el') {
					temp = { id:matched_variant_id, quantity:1, properties: { Συνταγές : recipes.toString(), Pet : name, ...attributes } };
				} else if (document.documentElement.lang == 'en') {
					temp = { id:matched_variant_id, quantity:1, properties: { Recipes : recipes.toString(), Pet : name, ...attributes } };
				} else {
					temp = { id:matched_variant_id, quantity:1, properties: { Recipes : recipes.toString(), Pet : name, ...attributes } };
				}
			} else {
				if (document.documentElement.lang == 'el') {
					temp = { id:matched_variant_id, quantity:1, selling_plan:matched_plan_id, properties: { Συνταγές : recipes.toString(), Pet : name, ...attributes } };
				} else if (document.documentElement.lang == 'en') {
					temp = { id:matched_variant_id, quantity:1, selling_plan:matched_plan_id, properties: { Recipes : recipes.toString(), Pet : name, ...attributes } };
				} else {
					temp = { id:matched_variant_id, quantity:1, selling_plan:matched_plan_id, properties: { Recipes : recipes.toString(), Pet : name, ...attributes } };
				}			
			}
		});

		this.finalProduct = temp;

		/*
			treats
			In case the user has also selected treats, this will create an object for each treat and add it to the finalProductArray.
		*/
		if(typeof(document.querySelector('extras-manager')) != 'undefined' && document.querySelector('extras-manager') != null){
			if(document.querySelector('extras-manager').dataset.hasextras == 'true') {
				this.finalProductArray = [];

				let trts = document.querySelectorAll('product-card.a-treat');				

				trts.forEach((trt) => {     
					if( Number(trt.dataset.item_totalqty) > 0 ) {
						let temp_trt = {id:Number(trt.dataset.item_id), quantity: Number(trt.dataset.item_totalqty)}
						this.finalProductArray.push(temp_trt);
					}
				});

				this.finalProductArray.push(temp);
			}
		}
	}


	
	/* ==========================
	=== Age related functions === 
	========================== */

	/* 
		this is used to show/hide the age fields based on the user's selection in step 2.
		this is done because dog age is in years, while puppy age is in months.
		Note that since age is required in any case (either puppy or adult), there is a switcheroo of the required attribute.
		Hiding a required field does not mean that it is not required, so the required attribute is switched between the two fields.
	*/
	age_toggleSelectors(element){
		element.checked && element.value == 'PUPPY' ? (
			this.dogPuppyAgeWrapper.classList.add('flex'),
			this.dogPuppyAgeWrapper.classList.remove('none'),        
			this.dogAdultAgeWrapper.classList.remove('flex'),
			this.dogAdultAgeWrapper.classList.add('none'),        
			this.dogPuppyAgeFields.setAttribute('required', true),
			this.dogAdultAgeFields.removeAttribute('required')   
		) : (
			this.dogAdultAgeWrapper.classList.add('flex'),
			this.dogAdultAgeWrapper.classList.remove('none'),         
			this.dogPuppyAgeWrapper.classList.remove('flex'),
			this.dogPuppyAgeWrapper.classList.add('none'),       
			this.dogAdultAgeFields.setAttribute('required', true),
			this.dogPuppyAgeFields.removeAttribute('required') 
		);
	}

	/*
		Complementary function to age_toggleSelectors
		FUTURE: Maybe these two can be combined into a single function
	*/
	age_resetSelector(element) {
		element.checked && element.value == 'PUPPY' ? (
			this.dogAdultAgeFields.selectedIndex = 0,
			this.label_ageAdult.classList.add('none')
		) : (
			this.dogPuppyAgeFields.selectedIndex = 0,
			this.label_agePuppy.classList.add('none')
		)
	}


	/* ================================
	=== Allergies related functions === 
	================================ */
	allergies_reset() {    
		this.allergiesArray = []; 
		this.data_write('_typeOfAllergies', this.allergiesArray);
		this.dogAllergiesFields.forEach((f) => {
			f.removeAttribute('required');
			f.checked = false;
			this.allergies_toggleAllergiesTextarea(false);
			this.data_write('_extraAllergies', '');
			this.extraAllergiesField.value = '';
		})    
	}

	allergies_toggleAllergiesPanel(state) {      
		state == false ? (           
			this.dogAllergiesWrapper.classList.add('none'), 
			this.dogAllergiesWrapper.classList.remove('block')
		) : (
			this.dogAllergiesWrapper.classList.add('block'),
			this.dogAllergiesWrapper.classList.remove('none'),        
			this.dogAllergiesFields.forEach((f)=>{ f.setAttribute('required', true) })    
		)
	}     

	allergies_toggleAllergiesTextarea(state){
		state == false ? (
			this.dogExtraAllergiesWrapper.classList.remove('flex'),
			this.dogExtraAllergiesWrapper.classList.add('none'),
			this.extraAllergiesField.removeAttribute('required')           
		) : (
			this.dogExtraAllergiesWrapper.classList.add('flex'),
			this.dogExtraAllergiesWrapper.classList.remove('none'),
			this.extraAllergiesField.setAttribute('required', true)
		);
	}


	/* ====================================
	=== Health issues related functions === 
	==================================== */
	healthIssues_reset() {   
		this.healthIssuesArray = [],
		this.data_write('_typeOfHealthIssues', this.healthIssuesArray)      
		this.dogHealthIssuesFields.forEach((f) => { f.removeAttribute('required'); f.checked = false });
		this.abortFlag = false;
	}

	healthIssues_toggleIssuesPanel(state) {
		state == false ? (           
			this.dogHealthIssuesWrapper.classList.add('none'), 
			this.dogHealthIssuesWrapper.classList.remove('block')
		) : (
			this.dogHealthIssuesWrapper.classList.add('block'),
			this.dogHealthIssuesWrapper.classList.remove('none'),        
			this.dogHealthIssuesFields.forEach((f)=>{ f.setAttribute('required', true) })    
		)   
	}


	/* ====================================
	=== Accessibility related functions === 
	==================================== */
	/* 
		This is not complete and needs REFACTORING / FURTHER DEVELOPMENT.
		The message should include the name of the field that is invalid along with a helpful message.
		Also, why not make the error message visible to all users and not only screen readers?
		The time when the screen reader reads the message is also an issue.
		Should the message be read when the user lands on a step that contains required fields? 
		Should the message be read when the user is on the next step button? (this currently cannot be done because the button is disabled, so the focus cannot reach it)
	*/
	a11y_updateLiveRegion(invalidFields, button) { 
		let region = this.querySelector('#plannerLiveRegion');    
		typeof(region) != 'undefined' && region != null ? region.remove() : null; 
		let clone = this.liveRegionTemplate.content.cloneNode(true);
		button.parentNode.insertBefore(clone, button);
		//this.liveRegionTemplate.parentNode.insertBefore(clone, this.liveRegionTemplate);
		this.querySelector('#plannerLiveRegion').textContent = `Βεβαιωθείτε ότι έχετε συμπληρώσει όλα τα πεδία`;
	}

	a11y_updateActivityRegion(desc) {
		let region = this.querySelector('#activityLiveRegion');
		typeof(region) != 'undefined' && region != null ? region.remove() : null;    
		let clone = this.activityRegionTemplate.content.cloneNode(true);
		this.activityRegionTemplate.parentNode.insertBefore(clone, this.activityRegionTemplate);
		this.querySelector('#activityLiveRegion').textContent = desc;            
	}  


	/* ===========================
	=== Cart related functions === 
	=========================== */  
	cart_clear() {
		const result = fetch("/cart/clear.js", {
			method: "POST",
			headers: {
				"Accept": "application/json"
			}
		});
	}

	async cart_addItems() { 

		// this.finalProductArray is populated by product_CreateFinalProduct before this is called.
		if (!this.finalProductArray || this.finalProductArray.length === 0) {
			console.error("cart_addItems: finalProductArray is empty. No items to add.");
			// Display an error to the user
			this.panels_toggle([
				[this.errorPanel, true], [this.abortPanel, false], [this.prefacePanel, false], [this.periodicityPanel, false], [this.preCheckoutPanel, false],
				[this.productsPanel, false], [this.unavailablePanel, false], [this.checkoutPanel, false], [this.loaderPanel, false]
			]);
			if(this.errorPanel) {
				const errorTitle = this.errorPanel.querySelector('h3'); 
				if (errorTitle) errorTitle.textContent = "No items selected"; 
				const errorP = this.errorPanel.querySelector('p'); 
				if (errorP) errorP.textContent = "Please select your desired recipes and quantities before proceeding.";
			}
			return { status: 400, error_message: "No items to add internally." }; 
		}

		const data = { items: this.finalProductArray };

		console.log("Sending to /cart/add.json:", JSON.stringify(data, null, 2)); // For debugging

		let response;
		try {
			response = await fetch("/cart/add.json", {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					"Accept": "application/json"
				},
				body: JSON.stringify(data)
			});

			if (!response.ok) { // Check for non-2xx responses
				let errorBody = {};
				try {
				    errorBody = await response.json(); // Attempt to parse error response
				} catch (e) {
				    errorBody.description = await response.text(); // Fallback to text if JSON parsing fails
				    console.error("Could not parse JSON error response from /cart/add.json. Raw response:", errorBody.description);
				}
				console.error(`Error from /cart/add.json: ${response.status}`, errorBody);
                if(this.errorPanel) {
                    const errorTitle = this.errorPanel.querySelector('h3');
                    if (errorTitle) errorTitle.textContent = `Error: ${response.status}`;
                    const errorP = this.errorPanel.querySelector('p');
                    if (errorP) errorP.textContent = errorBody.description || errorBody.message || "An unknown error occurred while adding to cart.";
                }
				return { status: response.status, error_message: errorBody.description || errorBody.message, response_body: errorBody };
			}

			const responseData = await response.json();
			console.log("Successfully added items to cart:", responseData);
			return { status: response.status, data: responseData }; // Return full response data on success

		} catch (error) {
			console.error("Network error or JSON parsing error in cart_addItems:", error);
            if(this.errorPanel) {
                const errorTitle = this.errorPanel.querySelector('h3');
                if (errorTitle) errorTitle.textContent = "Network Error";
                const errorP = this.errorPanel.querySelector('p');
                if (errorP) errorP.textContent = "Could not connect to the server to add items to your cart. Please check your internet connection and try again.";
            }
			return { status: 500, error_message: "Network error or problem parsing server response." }; 
		}
	}

	// async cart_setAttributes(attributes = {}) {    
	// 	const result = await fetch("/cart/update.json", {
	// 		method: "POST",
	// 		headers: {
	// 			"Content-Type": "application/json",
	// 			"Accept": "application/json"
	// 		},
	// 		body: JSON.stringify({ 
	// 			attributes: attributes
	// 			// note: ''+ this.querySelector('#Cart-note').value +''
	// 		})
	// 	});    
	// 	return result;
	// }  

	cart_DataToObject() {    
		const tempObj = {};
		this.dog.forEach((entry) => {         
			for (const propertyKey in entry) { // Use a more distinct variable name
				const key = propertyKey; // Key is already a string
				let value = entry[propertyKey];

				// Convert value to string for Shopify properties
				if (Array.isArray(value)) {
					value = value.join(', '); // Convert array to comma-separated string
				} else if (typeof value === 'object' && value !== null) {
					value = JSON.stringify(value); // Convert simple object to JSON string
				} else if (value === null || typeof value === 'undefined') {
                    value = ''; // Convert null/undefined to empty string
                } else {
					value = String(value); // Ensure everything else is a string
				}
				tempObj[key] = value;
			}  
		});   
		return tempObj;     
	}


	// NEW/MODIFIED METHODS FOR PORTION PRICING

	formatMoney(cents, format) { // The 'format' parameter is no longer used internally
		const amount = (cents / 100);
		// Standardize to use Intl.NumberFormat for Euro formatting, consistent with other parts of the code.
		// 'de-DE' locale is used as it's already present in other formatting calls.
		return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(amount);
	}
	

	updatePortionAndPrice(productHandle, newPortionValue, isPreview = false) {
		// console.log(`[DEBUG] updatePortionAndPrice CALLED for: ${productHandle}, Portions: ${newPortionValue}, Preview: ${isPreview}, Current Plan: ${this.planTypeValue}, Current Periodicity: ${this.periodicityValue}`);

		if (!this.recipeData || !this.recipeData[productHandle] || !this.recipeData[productHandle].variants) {
			console.error(`Recipe data or variants not found for ${productHandle}`);
			return;
		}

		const currentGramsPerDay = this.data_read(['_grams_per_day'])[0];
		let durationKeyPart = '';
		switch (this.periodicityValue) { // this.periodicityValue is '1', '2', or '4' (weeks)
			case '1': durationKeyPart = '1-ebdomada'; break;
			case '2': durationKeyPart = '2-ebdomades'; break;
			case '4': durationKeyPart = '4-ebdomades'; break; // Corrected typo here
			default:
				console.error('Invalid periodicityValue:', this.periodicityValue);
				return;
		}
		const grammageKeyPart = `${currentGramsPerDay}gr-mera`;
		const variantKey = `${durationKeyPart}_${grammageKeyPart}`;
		
		const variantData = this.recipeData[productHandle].variants[variantKey];

		if (!variantData) {
			console.warn(`Variant data not found for ${productHandle} with key ${variantKey}. This might be an unavailable combination.`);
			// Potentially disable input or show error for this specific recipe if combo is bad.
			// For now, just set price to 0 and don't update portions if variantData is missing.
			const productCard = this.querySelector(`.a-product .recipe-portion-input[data-product-handle="${productHandle}"]`).closest('.a-product');
			if (productCard) {
				const priceDisplay = productCard.querySelector('.recipe-price-display');
				priceDisplay.textContent = this.formatMoney(0, Shopify.currency.money_format);
			}
			if (!isPreview) {
				this.recipePortions[productHandle] = 0; // Reset portions if variant is bad
				this.calculateAndUpdateOverallTotal();
			}
			return;
		}

		let pricePerPortion = variantData.price; // Default to one-time purchase price
		if (this.planTypeValue === 'SUBSCRIPTION' && typeof variantData.discountedPrice !== 'undefined') {
			pricePerPortion = variantData.discountedPrice;
		}
		const recipeTotalCents = newPortionValue * pricePerPortion;

		const productCard = this.querySelector(`.a-product .recipe-portion-input[data-product-handle="${productHandle}"]`).closest('.a-product');
		if (productCard) {
			const priceDisplay = productCard.querySelector('.recipe-price-display');
			priceDisplay.textContent = this.formatMoney(recipeTotalCents, Shopify.currency.money_format);

			const portionDisplay = productCard.querySelector(`.recipe-portion-display[data-product-handle="${productHandle}"]`);
			if (portionDisplay) portionDisplay.textContent = newPortionValue; // Update span here too
		}
		
		if (!isPreview) { // Only update master portion count and overall total if not a preview
			this.recipePortions[productHandle] = newPortionValue;
			this.calculateAndUpdateOverallTotal();
		}
	}

	calculateAndUpdateOverallTotal() {
		let currentTotalSelectedPortions = 0;
		let overallRecipeTotalCents = 0;

		for (const handle in this.recipePortions) {
			const portions = this.recipePortions[handle];
			currentTotalSelectedPortions += portions;

			// Recalculate price for this recipe based on its current portions
			if (this.recipeData && this.recipeData[handle] && this.recipeData[handle].variants) {
				const currentGramsPerDay = this.data_read(['_grams_per_day'])[0];
				let durationKeyPart = '';
				switch (this.periodicityValue) {
					case '1': durationKeyPart = '1-ebdomada'; break;
					case '2': durationKeyPart = '2-ebdomades'; break;
					case '4': durationKeyPart = '4-ebdomades'; break;
				}
				const grammageKeyPart = `${currentGramsPerDay}gr-mera`;
				const variantKey = `${durationKeyPart}_${grammageKeyPart}`;
				const variantData = this.recipeData[handle].variants[variantKey];

				if (variantData) { // Ensure variantData exists
					let priceForCalc = variantData.price; // Default to one-time purchase price
					if (this.planTypeValue === 'SUBSCRIPTION' && typeof variantData.discountedPrice !== 'undefined') {
						priceForCalc = variantData.discountedPrice;
					}
					if (typeof priceForCalc !== 'undefined') { // Ensure priceForCalc is a number
						overallRecipeTotalCents += portions * priceForCalc;
					}
				}
			}
		}
		
		// console.log('Total Selected Portions:', currentTotalSelectedPortions, 'Required:', this.totalRequiredPortions);
		// console.log('Overall Recipe Total Cents:', overallRecipeTotalCents);

		// Update data attributes for the final total calculation
		this.final_total_wrapper.setAttribute('data-recipe_total', `${overallRecipeTotalCents}`);
		
		// NEW: Update .label_price elements
		const formattedOverallRecipePrice = this.formatMoney(overallRecipeTotalCents, Shopify.currency.money_format);
		this.labels_Price.forEach(label => {
			label.innerHTML = formattedOverallRecipePrice;
		});

		// NEW: Update .label_price_per_day elements
		if (this.periodicityDays > 0) {
			const pricePerDayCents = overallRecipeTotalCents / this.periodicityDays;
			const formattedPricePerDay = this.formatMoney(pricePerDayCents, Shopify.currency.money_format);
			this.labels_Price_per_day.forEach(label => {
				label.innerHTML = formattedPricePerDay;
			});
		} else {
			// Handle case where periodicityDays is 0 or invalid, e.g., display N/A
			this.labels_Price_per_day.forEach(label => {
				label.innerHTML = 'N/A'; 
			});
		}

		// Call the existing mutation observer's logic or replicate it
		// This assumes extras_total is already up-to-date or handled elsewhere
		let extras_total_cents = Number(this.final_total_wrapper.dataset.extras_total) || 0;
		let combined_total_cents = overallRecipeTotalCents + extras_total_cents;
		
		this.final_total_wrapper.setAttribute('data-total_total', `${combined_total_cents}`);
		if (this.label_combined_total) {
			this.label_combined_total.textContent = this.formatMoney(combined_total_cents, Shopify.currency.money_format);
		}

		// Update other labels (price per day might be tricky now as it depends on mix)
		// For now, let's simplify or remove the direct "price per day" if it's too complex
		// The this.labels_write() method might need adjustment for how it gets its main product price.

		// TODO: Add logic to enable/disable plus/minus buttons and inputs
		// based on currentTotalSelectedPortions vs this.totalRequiredPortions.
		// For example, if currentTotalSelectedPortions >= this.totalRequiredPortions,
		// disable all plus buttons and cap inputs.

		// Show/hide preCheckoutPanel and checkoutPanel based on whether any portions are selected
		if(currentTotalSelectedPortions > 0) {
			this.panels_toggle([ [this.preCheckoutPanel, true],  [this.checkoutPanel, true] ]);
		} else {
			this.panels_toggle([ [this.preCheckoutPanel, false], [this.checkoutPanel, false] ])
		}
	}

	add_totalTotal_MutationObserver() {
			
		let options = { attributes: true };         
		let temp = []
	
		let callback = (mutationList, observer) => {
			for (const mutation of mutationList) {
				if (mutation.type === 'attributes') {
					temp.push(mutation.target) 

					let recipe_total = Number(document.querySelector('.finalTotal').dataset.recipe_total);
					let extras_total = Number(document.querySelector('.finalTotal').dataset.extras_total);           
					let total = (recipe_total + extras_total) / 100;
					document.querySelector('.finalTotal .label_combined_total').textContent = `${new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(total)}`;                      
				}              
			}
		};

		let buldMutationObserver = new MutationObserver(callback);
		buldMutationObserver.observe(document.querySelector('.finalTotal'), options);

	}


	/* ==========
	=== Other === 
	========== */

	goto_page(element) {     
		element.click();  
	}

	// This is used to prevent the user from submitting the form by pressing Enter
	disableFormSubmission() {
		this.form.addEventListener('keydown', (e) => {
			e.key === "Enter" ? e.preventDefault() : null;                      
		})
	}

	/*
		This is used to handle step 4, where the user selects the health issues / allregies of the dog.
		The initial state is that there are no health issues or allergies, so the panels are hidden. (so all checkboxes are unchecked and not required)
		However, if the user selects that the dog has health issues / allergies, then the corresponding panel is shown and the checkboxes are required.
		This is done because the user must select at least one checkbox in each panel.
		If there is at least one checkbox selected, then the rest of the checkboxes are not required.
		Also, there is the following scenario:
			The user checks that the dog has health issues, selects one or more issues but then selects that the dog has no issues.
			In this case, the health issues checkboxes should not be required.
	*/
	toggleCheckBoxRequired(fields) {   
		let atLeastOneChecked = false;
		fields.forEach((f) => { if(f.checked == true) { atLeastOneChecked = true } });      
		if(atLeastOneChecked == true) {
			fields.forEach((f) => { f.removeAttribute('required') });
		} else {
			fields.forEach((f) => { atLeastOneChecked = false; f.setAttribute('required', true); }); 
		}
	}

	/* This will populate the dog breed datalist (#breedList) with the available breeds from this.breeds array.
	The datalist offers native suggestions to the user when typing in the breed input field */
	createBreedOptions() {
		this.breeds.forEach(b => {
			let b_option = document.createElement('OPTION');
			b_option.classList.add('a-dog-breed');
			b_option.value = `${b}`;
			this.breedList.append(b_option);
		})
	}

	grams_per_day_puppy() {
		// Read the age of the puppy (in months)
		let num_age = this.data_read(['_age'])[0];

		// Find the matched array of the puppy's age
		let matched_month_array = this[`kilogroup_${num_age}`];

		// Read the kilos of the puppy
		let num_kgs = this.data_read(['_weight'])[0];

		/*
			The findIndex() method is called with a function that returns true when the weight of the puppy matches a weight in the current sub-array (sub.indexOf(num_kgs) !== -1). 
			This means it finds the index of the weight group that matches the puppy's weight.
		*/
		let indexOfRemainingArray = matched_month_array.findIndex(function(sub) {
			return sub.indexOf(num_kgs) !== -1;
		});
		// console.log('grams_per_day_puppy', indexOfRemainingArray, this.fixed_grams[indexOfRemainingArray])
		return this.fixed_grams[indexOfRemainingArray];
	}

	/*
		this is used to show/hide the .fixed-pricing element
		it hides it when the .userRecipesObservable (in preCheckoutPanel) element is on screen
		and shows it when the element is not on screen.
		The switch is done because they display the same information, so there is no need to show both at the same time.
	*/
	fixed_pricing_panel_IO() {
		const observer = new IntersectionObserver(entries => {
			entries.forEach(entry => {
				entry.isIntersecting ? entry.target.classList.add('onScreen') : entry.target.classList.remove('onScreen');		  	
			})
		}, { threshold: 0.25 })	  
		observer.observe(this.querySelector('.userRecipesObservable'))
	}	


	/* =============================
	=== Paneλs related functions ===  
	============================= */ 

	// This is used to toggle the visibility of panels in step 5
	panels_toggle(parameters) {
		parameters.forEach((param) => {
			let element = param[0];
			let elState = param[1];       
			elState == true ? ( 
				element.classList.remove('none'), 
				element.classList.add('flex')
			) : (
				element.classList.remove('flex'), 
				element.classList.add('none')
			);     
		})   
	}

	// This is used to reset all panels in step 5 to display: none
	panels_reset() { 
		[ this.loaderPanel, this.prefacePanel, this.periodicityPanel, 
			this.checkoutPanel, this.productsPanel, this.planTypePanel, 
			this.abortPanel, this.unavailablePanel, this.errorPanel, this.preCheckoutPanel
		].forEach((panel) => { panel.classList.remove('flex'); panel.classList.add('none') })
	}

	/* 
		This is called only once in step 4, when the user clicks the button to proceed to the last step.
		This essentially prepares the panels for step 5, based on the user's selections in the previous steps.
		For example: 
			if the user has selected any allergies, e.g: the dog is allergic to chicken, do not show chicken recipe.
			if the user has selected any critical health issues, e.g: dog has kidney problems (this.abortFlag == true), do not show the recipes but show the abort panel instead
			if the dog requires less than 600grams of food per day, disable the weekly option and select the monthly option
			etc.
		
		FUTURE: Loader could remain for a longer time to emulate a 'thinking' state
	*/
	panels_set_step5() { 
		// THIS METHOD IS NOW LARGELY REPLACED BY initializeStep5View.
		// The goto5 listener in listeners_Step4() should be the sole initiator of initializeStep5View.
		console.warn("DEPRECATED CALL: panels_set_step5() was called. All essential functionality has moved to initializeStep5View(). Review call stack if issues persist or if this method is being called from unexpected places.");

		// All former logic for initial portion distribution and panel toggling 
		// has been moved to initializeStep5View and MUST NOT be duplicated or present here.
	}  


	/* ==============================
	=== Product related functions === 
	============================== */

	// unchecked all recipe products    
	products_reset() {
		this.products.forEach((prod) => {
			// prod.querySelector('input').checked = false; // Old checkbox
			const portionInput = prod.querySelector('.recipe-portion-input');
			if(portionInput) portionInput.value = 0;
			const portionDisplay = prod.querySelector('.recipe-portion-display'); // Get the span
			if(portionDisplay) portionDisplay.textContent = '0'; // Update the span

			const priceDisplay = prod.querySelector('.recipe-price-display');
			if(priceDisplay) priceDisplay.textContent = this.formatMoney(0, Shopify.currency.money_format);
		});
		// this.currentCheckedPrdCnt = 0; // Old counter
		this.recipePortions = {}; // Reset stored portions
		this.calculateAndUpdateOverallTotal(); // Update totals
	}    

	/*
		This is used to filter (show/hide in essence) recipes based on the user's selections in the previous steps.
		For example, if the user has selected that the dog is allergic to chicken, then the chicken recipe will be hidden.
		If the user has selected that the dog is a puppy, then the adult recipes will be hidden and the puppy recipes will be shown.
	*/
	// @DEPRECATED - Use applyRecipeFilters() instead. Legacy function kept for compatibility.
	products_filter(allergiesArray){
		let allergyType; 
		this.products.forEach(prd => { prd.classList.remove('none') })

        // Filter by health issues
		if(Array.isArray(this.data_read(['_typeOfHealthIssues'])[0]) && this.data_read(['_typeOfHealthIssues'])[0].includes('HEALTH_ISSUE_KIDNEY')) {
			this.products.forEach(prd => {
			  if(prd.dataset.renal == 'false') {
				  prd.classList.add('none');
				  const portionInput = prd.querySelector('.recipe-portion-input');
				  if(portionInput) portionInput.value = 0;
				  const portionDisplay = prd.querySelector('.recipe-portion-display');
				  if(portionDisplay) portionDisplay.textContent = '0';
			  } else if (prd.dataset.renal == 'true') {         
				prd.classList.remove('none');
				let renalPreface = this.querySelectorAll(`.renal-suggestion`);
				let generalPreface = this.querySelectorAll(`.recipe-suggestion`);
				let renalDisclaimer = this.querySelectorAll(`.disclaimer-renal`);
				renalPreface.forEach(el => el.style.display = 'block');
				generalPreface.forEach(el => el.style.display = 'none');
				renalDisclaimer.forEach(el => el.style.display = 'block');
			  }
			})
		  } else {
			this.products.forEach(prd => {
			  if(prd.dataset.renal == 'false' && this.data_read(['_adulthood'])[0] == 'ADULT') {
				  prd.classList.remove('none');
			  } else if (prd.dataset.renal == 'true') {         
				prd.classList.add('none');
				const portionInput = prd.querySelector('.recipe-portion-input');
				if(portionInput) portionInput.value = 0;
				const portionDisplay = prd.querySelector('.recipe-portion-display');
				if(portionDisplay) portionDisplay.textContent = '0';
			  }
			})
			let renalPreface = this.querySelectorAll(`.renal-suggestion`);
			let generalPreface = this.querySelectorAll(`.recipe-suggestion`);
			let renalDisclaimer = this.querySelectorAll(`.disclaimer-renal`);
			renalPreface.forEach(el => el.style.display = 'none');
			generalPreface.forEach(el => el.style.display = 'block');
			renalDisclaimer.forEach(el => el.style.display = 'none');
		  }
		
		// Filter by adulthood            
		if(this.data_read(['_adulthood'])[0] != null) {
		
			if(this.data_read(['_adulthood'])[0] == 'PUPPY') {
				this.products.forEach(prd => {  
					if(prd.dataset.puppies == 'false') {
						prd.classList.add('none');
						// prd.querySelector('input').checked = false; // Old checkbox
						const portionInput = prd.querySelector('.recipe-portion-input');
						if(portionInput) portionInput.value = 0;
						const portionDisplay = prd.querySelector('.recipe-portion-display');
						if(portionDisplay) portionDisplay.textContent = '0';

					}     
				})
			}

			if(this.data_read(['_adulthood'])[0] == 'ADULT') {
				this.products.forEach(prd => {  
					if(prd.dataset.adult == 'false') {
						prd.classList.add('none');
						// prd.querySelector('input').checked = false; // Old checkbox
						const portionInput = prd.querySelector('.recipe-portion-input');
						if(portionInput) portionInput.value = 0;
						const portionDisplay = prd.querySelector('.recipe-portion-display');
						if(portionDisplay) portionDisplay.textContent = '0';
					}     
				})
			}
		
		}
		
		// Filter by allergy
		if(allergiesArray[0].length > 0) {

			allergiesArray[0].forEach((allergy) => {      
			let temp = allergy.split('_');
			allergyType = temp[0];
			this.querySelectorAll(`.a-product[data-meat="${allergyType}"]`).forEach((prd) => { 
				prd.classList.add('none');
				const portionInput = prd.querySelector('.recipe-portion-input');
				if(portionInput) portionInput.value = 0;
				const portionDisplay = prd.querySelector('.recipe-portion-display');
				if(portionDisplay) portionDisplay.textContent = '0';
			})         
			});

			this.querySelectorAll(`.a-product`).length == this.querySelectorAll(`.a-product.none`).length ? this.unavailableFlag = true : this.unavailableFlag = false;       
	
		} else { this.unavailableFlag = false }


		this.calculateAndUpdateOverallTotal(); // Recalculate after filtering
	}
  
	/**
	 * New unified filtering system using window.masterRecipeData
	 * Filters recipes based on allergies, health issues, and age appropriateness
	 */
	applyRecipeFilters() {
		// console.log("Applying unified recipe filters...");
		
		// Reset all products to visible first
		this.products.forEach(prd => { 
			prd.classList.remove('none');
			// Reset portions when filtering
			const portionInput = prd.querySelector('.recipe-portion-input');
			const portionDisplay = prd.querySelector('.recipe-portion-display');
			if(portionInput) portionInput.value = 0;
			if(portionDisplay) portionDisplay.textContent = '0';
		});

		// Get user profile data
		const allergiesArray = this.data_read(['_typeOfAllergies'])[0] || [];
		const healthIssues = this.data_read(['_typeOfHealthIssues'])[0] || [];
		const adulthood = this.data_read(['_adulthood'])[0];
		const hasRenalIssue = Array.isArray(healthIssues) && healthIssues.includes('HEALTH_ISSUE_KIDNEY');
		const hasHepaticIssue = Array.isArray(healthIssues) && healthIssues.includes('HEALTH_ISSUE_LIVER_DISEASE');

		console.log("Filter criteria:", { allergiesArray, healthIssues, adulthood, hasRenalIssue, hasHepaticIssue });

		// Filter each product based on its metadata in window.masterRecipeData
		this.products.forEach(productElement => {
			const productHandle = productElement.dataset.productHandle;
			const recipeData = window.masterRecipeData[productHandle];
			
			if (!recipeData) {
				console.warn(`No recipe data found for ${productHandle}`);
				return;
			}

			let shouldHide = false;

			// 1. Handle renal case - show only renal recipes if user has kidney issues
			if (hasRenalIssue) {
				if (!recipeData.isRenal) {
					shouldHide = true;
					// console.log(`Hiding non-renal recipe: ${productHandle}`);
				} else {
					// console.log(`Showing renal recipe: ${productHandle}`);
				}
			} else {
				// If no kidney issues, hide renal recipes
				if (recipeData.isRenal) {
					shouldHide = true;
					// console.log(`Hiding renal recipe: ${productHandle}`);
				}
			}

			// 1b. Handle hepatic case - show only hepatic recipes if user has liver disease
			if (hasHepaticIssue) {
				if (!recipeData.isHepatic) {
					shouldHide = true;
				}
			} else {
				// If no liver disease, hide hepatic recipes
				if (recipeData.isHepatic) {
					shouldHide = true;
				}
			}

			// 2. Filter by age appropriateness
			if (!shouldHide && adulthood) {
				if (adulthood === 'PUPPY' && !recipeData.forPuppies) {
					shouldHide = true;
					// console.log(`Hiding non-puppy recipe for puppy: ${productHandle}`);
				} else if (adulthood === 'ADULT' && !recipeData.forAdults) {
					shouldHide = true;
					// console.log(`Hiding non-adult recipe for adult: ${productHandle}`);
				}
			}

			// 3. Filter by allergies
			if (!shouldHide && Array.isArray(allergiesArray) && allergiesArray.length > 0) {
				for (const allergy of allergiesArray) {
					// Extract the allergen type (e.g., 'CHICKEN' from 'CHICKEN_ALLERGY')
					const allergenType = allergy.split('_')[0];
					if (recipeData.meatType === allergenType) {
						shouldHide = true;
						// console.log(`Hiding ${allergenType} recipe due to allergy: ${productHandle}`);
						break;
					}
				}
			}

			// Apply the filtering
			if (shouldHide) {
				productElement.classList.add('none');
			}
		});

		// Update UI based on results
		const visibleProducts = this.querySelectorAll('.a-product:not(.none)');
		const hasNoVisibleProducts = visibleProducts.length === 0;
		
		// Update unavailable flag
		this.unavailableFlag = hasNoVisibleProducts;

		// Update preface text based on renal/hepatic case
		const renalPreface = this.querySelectorAll('.renal-suggestion');
		const hepaticPreface = this.querySelectorAll('.hepatic-suggestion');
		const generalPreface = this.querySelectorAll('.recipe-suggestion');
		const renalDisclaimer = this.querySelectorAll('.disclaimer-renal');
		const hepaticDisclaimer = this.querySelectorAll('.disclaimer-hepatic');

		if (hasRenalIssue) {
			renalPreface.forEach(el => el.style.display = 'block');
			hepaticPreface.forEach(el => el.style.display = 'none');
			generalPreface.forEach(el => el.style.display = 'none');
			renalDisclaimer.forEach(el => el.style.display = 'block');
			hepaticDisclaimer.forEach(el => el.style.display = 'none');
		} else if (hasHepaticIssue) {
			renalPreface.forEach(el => el.style.display = 'none');
			hepaticPreface.forEach(el => el.style.display = 'block');
			generalPreface.forEach(el => el.style.display = 'none');
			renalDisclaimer.forEach(el => el.style.display = 'none');
			hepaticDisclaimer.forEach(el => el.style.display = 'block');
		} else {
			renalPreface.forEach(el => el.style.display = 'none');
			hepaticPreface.forEach(el => el.style.display = 'none');
			generalPreface.forEach(el => el.style.display = 'block');
			renalDisclaimer.forEach(el => el.style.display = 'none');
			hepaticDisclaimer.forEach(el => el.style.display = 'none');
		}

		// console.log(`Filtering complete. Visible products: ${visibleProducts.length}, Unavailable flag: ${this.unavailableFlag}`);
	}

	/*
    	This function filters entries of variantsArray and returns those that match the condition.
		The condition is that the first element of the entry (Product Title) must match the data-match attribute of the periodicityField.
		Also, the data_read(['_grams_per_day']) value must match the variant[2].
		E.g: If the user has selected 'Φαγητό για 4 εβδομάδες' option, then this will return the variant that has the title 'Φαγητό για 4 εβδομάδες' 
		and the data_read(['_grams_per_day']) value. Check the console.log() to see the filtered array.
	*/
	products_filterIDS(periodicityField) {

		// Check if the source arrays are populated, if not, return empty array.
		// Fallback to use the globalVariables directly if they exist, otherwise assign empty arrays to avoid undefined errors.
		const variantsArrayToUse = this.globalVariables && this.globalVariables.product_variants_capture ? this.globalVariables.product_variants_capture : [];
		const variantsArrayRenalToUse = this.globalVariables && this.globalVariables.product_variants_renal_capture ? this.globalVariables.product_variants_renal_capture : [];
		const variantsArrayHepaticToUse = this.globalVariables && this.globalVariables.product_variants_hepatic_capture ? this.globalVariables.product_variants_hepatic_capture : [];

		if (variantsArrayToUse.length === 0 && variantsArrayRenalToUse.length === 0 && variantsArrayHepaticToUse.length === 0) {
			console.warn('products_filterIDS: product_variants_capture, product_variants_renal_capture and product_variants_hepatic_capture are empty or not initialized. This function may be deprecated or the data source is missing.');
			// return []; // If we absolutely must return an empty array when no variants are found
		}

		const healthIssuesForFilter = this.data_read(['_typeOfHealthIssues'])[0];
		if (Array.isArray(healthIssuesForFilter) && healthIssuesForFilter.includes('HEALTH_ISSUE_KIDNEY')) {
			// console.log('renal', true);
			var filtered = variantsArrayRenalToUse.filter(entry => entry[0] == `${periodicityField.dataset.match}` && entry[2] == this.data_read(['_grams_per_day']) );
		} else if (Array.isArray(healthIssuesForFilter) && healthIssuesForFilter.includes('HEALTH_ISSUE_LIVER_DISEASE')) {
			// console.log('hepatic', true);
			var filtered = variantsArrayHepaticToUse.filter(entry => entry[0] == `${periodicityField.dataset.match}` && entry[2] == this.data_read(['_grams_per_day']) );
		} else {
			// console.log('renal/hepatic', false);
			var filtered = variantsArrayToUse.filter(entry => entry[0] == `${periodicityField.dataset.match}` && entry[2] == this.data_read(['_grams_per_day']) );
		}
		return filtered;

	}

	product_CreateFinalProduct(matchedProduct, recipes, name) { // This will need significant rework for new cart structure

		let attributes = this.cart_DataToObject();  
		let itemsForCart = [];

		// Logic for recipes based on this.recipePortions and this.recipeData
		for (const productHandle in this.recipePortions) {
			const portions = this.recipePortions[productHandle];
			if (portions > 0 && this.recipeData[productHandle] && this.recipeData[productHandle].variants) {
				const currentGramsPerDay = this.data_read(['_grams_per_day'])[0];
				let durationKeyPart = '';
				switch (this.periodicityValue) {
					case '1': durationKeyPart = '1-ebdomada'; break;
					case '2': durationKeyPart = '2-ebdomades'; break;
					case '4': durationKeyPart = '4-ebdomades'; break;
				}
				const grammageKeyPart = `${currentGramsPerDay}gr-mera`;
				const variantKey = `${durationKeyPart}_${grammageKeyPart}`;
				const variantData = this.recipeData[productHandle].variants[variantKey];

				if (variantData && variantData.variantId) {
					let item = {
						id: variantData.variantId, // Changed from variantData.id to variantData.variantId
						quantity: portions, 
						properties: {
							_recipe_title: this.recipeData[productHandle].productTitle, // Or some other identifier
							Pet: name,
							// ... potentially other recipe-specific properties from variantData if needed
						}
					};
					// Add all dog profile attributes to each recipe line item
					for (const attrKey in attributes) {
						item.properties[attrKey] = attributes[attrKey];
					}


					// Handle selling plan if it's a subscription
					if (this.planTypeValue === 'SUBSCRIPTION' && variantData.sellingPlanId) {
						// sellingPlanId is now an array: [1week, 2weeks, 4weeks]
						// Map periodicityValue to array index
						let sellingPlanIndex = 0;
						switch(this.periodicityValue) {
							case '1': sellingPlanIndex = 0; break;
							case '2': sellingPlanIndex = 1; break;
							case '4': sellingPlanIndex = 2; break;
							default: sellingPlanIndex = 2; // Default to 4 weeks
						}
						item.selling_plan = Array.isArray(variantData.sellingPlanId) 
							? variantData.sellingPlanId[sellingPlanIndex] 
							: variantData.sellingPlanId; // Fallback for old format
					}
					itemsForCart.push(item);
				}
			}
		}


		// Logic for treats (remains similar, but ensure it's added to itemsForCart)
		if(typeof(document.querySelector('extras-manager')) != 'undefined' && document.querySelector('extras-manager') != null){
			if(document.querySelector('extras-manager').dataset.hasextras == 'true') {
				let trts = document.querySelectorAll('product-card.a-treat');				
				trts.forEach((trt) => {     
					if( Number(trt.dataset.item_totalqty) > 0 ) {
						let temp_trt = {
							id:Number(trt.dataset.item_id), 
							quantity: Number(trt.dataset.item_totalqty),
							properties: { // Also add pet name to treats if desired
								Pet: name
							}
						};
						if (trt.dataset.item_policy && this.planTypeValue === 'SUBSCRIPTION') { // Assuming item_policy stores selling_plan_id for treats
							// This part is speculative, depends on how selling plans for treats are handled
							// temp_trt.selling_plan = trt.dataset.item_policy; 
						}
						itemsForCart.push(temp_trt);
					}
				});
			}
		}
		
		this.finalProductArray = itemsForCart; // Update this to be the array of all items
		// console.log('Final items for cart:', this.finalProductArray);
	}


	/* ==========================
	=== Validation related functions === 
	============================== */
	validation_stepFields(fields, nextBtn) {
		let invalidFields = [];
		let flagValid = true; 

		fields.forEach((field) => { 
			if (field.type === 'radio' || field.type === 'checkbox') {
				const fieldSet = field.closest('fieldset') || field.closest('.fieldWrapper'); // Find a common parent
				const groupName = field.name;
				const groupFields = this.querySelectorAll(`[name="${groupName}"]`);
				let oneChecked = false;
				groupFields.forEach(gf => { if (gf.checked) oneChecked = true; });

				if (field.hasAttribute('required') && !oneChecked) {
					flagValid = false;
					if(fieldSet) this.validation_toggleStyle(false, fieldSet);
					invalidFields.push(field); // Add one field from the group for reporting
				} else {
					if(fieldSet) this.validation_toggleStyle(true, fieldSet);
				}
			} else { // For text, select, textarea
				if (field.validity.valueMissing == true && field.hasAttribute('required')) {         
					flagValid = false; 
					this.validation_toggleStyle(false, field.closest('.fieldWrapper'));          
					invalidFields.push(field)           
				} else { 
					this.validation_toggleStyle(true, field.closest('.fieldWrapper'));
					invalidFields = invalidFields.filter(f => f !== field); // Corrected filter
				}
			} 
		}); 

		flagValid == true ? this.validation_toggleStepBtn(true, nextBtn) : (this.validation_toggleStepBtn(false, nextBtn), this.a11y_updateLiveRegion(invalidFields, nextBtn) )
		return flagValid;        
	}

	validation_toggleStyle(state, element) {
		if (!element) return;
		state == false ? ( 
			element.classList.remove('validField'), element.classList.add('invalidField') 
		) : ( 
			element.classList.remove('invalidField'), element.classList.add('validField') 
		);      
	}                   


	validation_toggleStepBtn(state, element){
		if (!element) return;
		state == false ? ( 
			element.setAttribute('aria-disabled', 'true'), 
			element.setAttribute('disabled', 'true'), 
			element.classList.add('disabled')
		) : ( 
			element.removeAttribute('aria-disabled'), 
			element.removeAttribute('disabled'), 
			element.classList.remove('disabled') 
		)        
	}    

	validation_toggleTab(state, elements) {
		elements.forEach((element) => {
			if (element && element.tagName == 'LI' && element.querySelector('a')) {
				state == false ? (
					element.classList.add('disabled'), element.querySelector('a').setAttribute('aria-disabled', 'true')
				) : (
					element.classList.remove('disabled'), element.querySelector('a').removeAttribute('aria-disabled', 'true')
				)
			}
		})
	}


	/* =========================
	=== Label Text functions === 
	========================= */
	labels_write(data = {}) { // Added data param for specific updates
		// Update name if provided
		if (data.name) {
			this.labels_Name.forEach((ln) => { ln.innerHTML = data.name[0] || '' });
		}

		// Update gender-related labels if gender is provided
		if (data.gender) {
			const genderValue = data.gender[0];
			genderValue == 'FEMALE' ? (          
				this.labels_Gender.forEach((lg)    => { lg.innerHTML = 'η' }),         
				this.labels_Gender2.forEach((lg2)  => { lg2.innerHTML = 'την' }),        
				this.labels_Adulthood.forEach((la) => { la.innerHTML = 'ενήλικη' })
			) : (         
				this.labels_Gender.forEach((lg)    => { lg.innerHTML = 'o' }),        
				this.labels_Gender2.forEach((lg2)  => { lg2.innerHTML = 'τον' }),        
				this.labels_Adulthood.forEach((la) => { la.innerHTML = 'ενήλικος' })                
			);
		}
		
		// Update age-related labels if age is provided
		if (data.age) {
			const ageValue = data.age;
			const adulthood = this.data_read(['_adulthood'])[0];
			if (adulthood == 'ADULT') {
				if(this.label_ageAdult) this.label_ageAdult.classList.remove('none');
				if(this.label_agePuppy) this.label_agePuppy.classList.add('none');
				if(this.label_ageAdult) this.label_ageAdult.textContent = ageValue == '1' ? 'έτους' : 'ετών';
			} else if (adulthood == 'PUPPY') {
				if(this.label_agePuppy) this.label_agePuppy.classList.remove('none');
				if(this.label_ageAdult) this.label_ageAdult.classList.add('none');
				// Puppy age label already has "months" from HTML, value is just number
			}
		}

		// Update grams per day if provided
		if (data.grams) { // Assuming 'grams' here actually means the selected weight that determines grams
			const gramsPerDay = this.data_read(['_grams_per_day'])[0];
			this.labels_GramsPerDay.forEach((gpd) => { gpd.innerHTML = gramsPerDay || 'N/A' });
		}
							
		// periodicity and days based on instance properties (this.periodicityValue, this.periodicityDays)
		this.labels_Periodicity.forEach(l_periodicity => {
			l_periodicity.innerHTML = this.periodicityValue || 'N/A';
		})		

		if(this.periodicityValue == '1') {
			this.labels_week.forEach(l_week => { l_week.style.display = 'initial' });
			this.labels_weeks.forEach(l_weeks => { l_weeks.style.display = 'none' });
		} else {
			this.labels_week.forEach(l_week => { l_week.style.display = 'none' });
			this.labels_weeks.forEach(l_weeks => { l_weeks.style.display = 'initial' });
		}
		this.labels_Days.forEach((days) => { days.innerHTML = this.periodicityDays || 'N/A'; });


		// Price labels are now handled by calculateAndUpdateOverallTotal due to complexity
		// We can remove the old price logic from here.
		// The .finalTotal is updated by calculateAndUpdateOverallTotal
		// The per-recipe price is updated by updatePortionAndPrice

		// this.add_totalTotal_MutationObserver(); // This might still be relevant if other things update total directly
	}

	callback_periodicity_radios(radio) {
		if (radio.checked == true) { 
			this.data_write('_periodicity', radio.value);
			this.periodicityValue = radio.value;
			this.periodicityDays = parseInt(radio.dataset.days, 10) || (parseInt(radio.value, 10) * 7);
			this.totalRequiredPortions = this.periodicityDays;
			
			// console.log('Periodicity changed. New totalRequiredPortions:', this.totalRequiredPortions);

			if (this.isManualMode) {
				this.toggleManualMode(false);
			}
			
			// Instead of manually distributing here, call the centralized function
			this.redistributePortionsAndUpdateDisplay(); 
			this.renderRecipeCardsState(); // Re-render card states, in case of disable/enable changes
			
			this.labels_write(); // This will update labels like total days, periodicity value
			// calculateAndUpdateOverallTotal is called by redistributePortionsAndUpdateDisplay via updatePortionAndPrice
		}
	}

	callback_plantype_radios(radio) {
		if(radio.checked == true) {
			this.data_write('_typeOfPlan', radio.value);    			
			this.planTypeValue = radio.value;

			// Store manual mode state to restore it later
			const wasInManualMode = this.isManualMode;

			// Track if we need to redistribute portions due to periodicity change
			let periodicityChanged = false;
			const previousPeriodicity = this.periodicityValue;
			const previousTotalPortions = this.totalRequiredPortions;

			if(radio.value == 'SUBSCRIPTION') {
				this.panels_toggle([ [this.planTypeDescription_s, true], [this.planTypeDescription_o, false] ]);
				// Logic for disabling weekly option based on grams, specific to dog planner, adjust if needed
				if(this.data_read(['_grams_per_day'])[0] <= 600) { // Ensure _grams_per_day is correctly populated
					const weeklyOption = this.querySelector('#period_weekly');
					const monthlyOption = this.querySelector('#period_monthly');
					if (weeklyOption && monthlyOption && weeklyOption.checked) {
						// Only force change if weekly is currently selected
						weeklyOption.disabled = true;
						weeklyOption.checked = false;
						monthlyOption.checked = true; // Default to monthly
						
						this.data_write('_periodicity', monthlyOption.value); 
						this.periodicityValue = monthlyOption.value;
						this.periodicityDays = parseInt(monthlyOption.dataset.days, 10) || (parseInt(monthlyOption.value, 10) * 7);
						this.totalRequiredPortions = this.periodicityDays;
						periodicityChanged = true; // Mark that periodicity actually changed

						weeklyOption.classList.add('border-gray');
						if (weeklyOption.previousElementSibling) weeklyOption.previousElementSibling.classList.add('not-allowed');
						if (weeklyOption.parentElement) weeklyOption.parentElement.classList.add('not-allowed', 'opacity-05');
					} else if (weeklyOption) {
						// Just disable the option but don't change selection
						weeklyOption.disabled = true;
						weeklyOption.classList.add('border-gray');
						if (weeklyOption.previousElementSibling) weeklyOption.previousElementSibling.classList.add('not-allowed');
						if (weeklyOption.parentElement) weeklyOption.parentElement.classList.add('not-allowed', 'opacity-05');
					}
				} else {
					const weeklyOption = this.querySelector('#period_weekly');
					if (weeklyOption) {
						weeklyOption.disabled = false;
						weeklyOption.classList.remove('border-gray');
						if (weeklyOption.previousElementSibling) weeklyOption.previousElementSibling.classList.remove('not-allowed');
						if (weeklyOption.parentElement) weeklyOption.parentElement.classList.remove('not-allowed', 'opacity-05');
					}
				} 
			} else { // ONE_TIME purchase
				this.panels_toggle([ [this.planTypeDescription_s, false], [this.planTypeDescription_o, true] ])
				const weeklyOption = this.querySelector('#period_weekly');
				if (weeklyOption) {
					weeklyOption.disabled = false;
					weeklyOption.classList.remove('border-gray');
					if (weeklyOption.previousElementSibling) weeklyOption.previousElementSibling.classList.remove('not-allowed');
					if (weeklyOption.parentElement) weeklyOption.parentElement.classList.remove('not-allowed', 'opacity-05');
				}
			} 

			// If periodicity actually changed, redistribute portions and exit manual mode
			if (periodicityChanged) {
				// console.log('Plan type change triggered periodicity change, redistributing portions');
				if (wasInManualMode) {
					this.toggleManualMode(false); // Exit manual mode due to periodicity change
				}
				this.redistributePortionsAndUpdateDisplay();
			} else {
				// Otherwise, just update prices while preserving current portions AND manual mode state
				// console.log('Plan type change without periodicity change, preserving portions and manual mode state. Current portions:', this.recipePortions);
				this.activeRecipeHandles.forEach(productHandle => {
					// Use the currently stored portions for this recipe
					const currentPortions = this.recipePortions[productHandle] || 0; 
					// console.log(`Preserving ${currentPortions} portions for ${productHandle}`);
					this.updatePortionAndPrice(productHandle, currentPortions); 
				});
				
				// Restore manual mode state if it was enabled and no periodicity change occurred
				if (wasInManualMode && !this.isManualMode) {
					// console.log('Restoring manual mode state after plan type change');
					this.toggleManualMode(true, true); // Restore manual mode, skip redistribution
				}
			}
			
			this.labels_write(); // Update general labels like plan type description related texts.
			
			// Ensure overall total is correct if no active recipes, or to finalize sum.
			if (this.activeRecipeHandles.length === 0) {
				this.calculateAndUpdateOverallTotal();
			}
		}
	}

	// This function will replace parts of the old panels_set_step5 logic
	initializeStep5View() {
		// console.log("Initializing Step 5 View...");
		this.activeRecipeHandles = []; // Reset active recipes
		this.recipePortions = {};      // Reset current portions for all recipes

		this.panels_reset(); // Hide all panels (loader, error, abort, etc.)
		// We show loaderPanel immediately after panels_reset and before other operations.
		this.panels_toggle([ [this.loaderPanel, true] ]); 

		// Ensure product visibility is set based on dog's profile (allergies, health issues)
		this.applyRecipeFilters(); 

		const checkedPeriodicityRadio = Array.from(this.periodicityFields).find(radio => radio.checked) || this.periodicityFields[0];
		if (checkedPeriodicityRadio) {
			this.data_write('_periodicity', checkedPeriodicityRadio.value); 
			this.periodicityValue = checkedPeriodicityRadio.value;
			this.periodicityDays = parseInt(checkedPeriodicityRadio.dataset.days, 10) || (parseInt(checkedPeriodicityRadio.value, 10) * 7);
			this.totalRequiredPortions = this.periodicityDays;
			// console.log("Initial totalRequiredPortions set to:", this.totalRequiredPortions);
		} else {
			this.periodicityValue = '4'; 
			this.periodicityDays = 28; 
			this.totalRequiredPortions = 28; 
			// console.warn("No periodicity radio found, defaulting totalRequiredPortions.");
		}
		
		// Special handling for renal case
		const hasRenalIssue = Array.isArray(this.data_read(['_typeOfHealthIssues'])[0]) &&
		this.data_read(['_typeOfHealthIssues'])[0].includes('HEALTH_ISSUE_KIDNEY');

		// Special handling for hepatic case
		const hasHepaticIssue = Array.isArray(this.data_read(['_typeOfHealthIssues'])[0]) &&
		this.data_read(['_typeOfHealthIssues'])[0].includes('HEALTH_ISSUE_LIVER_DISEASE');

		if (hasRenalIssue || hasHepaticIssue) {
			// In renal/hepatic case, find the available recipe and auto-activate it
			const visibleProducts = this.querySelectorAll('.a-product:not(.none)');

			if (visibleProducts.length === 1) {
				const specialProduct = visibleProducts[0];
				const productHandle = specialProduct.dataset.productHandle;

				// Auto-activate the recipe
				this.activeRecipeHandles = [productHandle];
				this.recipePortions[productHandle] = this.totalRequiredPortions;

				// Update the price and display
				this.updatePortionAndPrice(productHandle, this.totalRequiredPortions);

				// Hide the manual mode toggle since there's only one recipe
				if (this.customPortionControls) {
					this.customPortionControls.classList.add('is-hidden');
				}
			}
		}
		
		this.renderRecipeCardsState(); 
		this.labels_write();           
		this.calculateAndUpdateOverallTotal();

		// Set up listener for the manual mode toggle button
		if (this.manualModeToggle) {
			this.manualModeToggle.addEventListener('change', () => this.toggleManualMode());
		}

		// Reset manual mode on re-initialization
		if (this.isManualMode) {
			this.toggleManualMode(false);
		}

		// Add/Re-add listeners
		this.products = this.querySelectorAll('.a-product'); // Refresh the NodeList
		// console.log('Attaching listeners to product cards. Count:', this.products.length);
		if (!this.boundHandleRecipeCardClick) { // Bind only once
		    this.boundHandleRecipeCardClick = this.handleRecipeCardClick.bind(this);
		}

		this.products.forEach(productCard => {
			productCard.removeEventListener('click', this.boundHandleRecipeCardClick);
			productCard.addEventListener('click', this.boundHandleRecipeCardClick);
		});
		// console.log("Recipe card click listeners cycle complete.");

		this.panels_toggle([
			[this.productsPanel, true],
			[this.prefacePanel, true],
			[this.planTypePanel, true],
			[this.periodicityPanel, true],
			[this.loaderPanel, false] 
		]);

		// For renal/hepatic case, also show the checkout panels since the recipe is auto-activated
		if ((hasRenalIssue || hasHepaticIssue) && this.activeRecipeHandles.length > 0) {
			this.panels_toggle([
				[this.preCheckoutPanel, true],
				[this.checkoutPanel, true]
			]);
		}

		if(this.abortFlag == true) { 
			this.panels_reset(); 
			this.panels_toggle([ [this.abortPanel, true] ]);
		} else if (this.unavailableFlag == true && this.querySelectorAll('.a-product:not(.none)').length === 0) {
			this.panels_reset();
			this.panels_toggle([ [this.unavailablePanel, true] ]);
		}
	}

	renderRecipeCardsState() {
		// console.log("Rendering recipe card states. Active: ", this.activeRecipeHandles, "Manual Mode:", this.isManualMode);
		const visibleProducts = this.querySelectorAll('.a-product:not(.none)'); // Get all products not hidden by filters
		
		// Check if we're in a renal or hepatic case
		const healthIssuesArr = this.data_read(['_typeOfHealthIssues'])[0];
		const hasRenalIssue = Array.isArray(healthIssuesArr) && healthIssuesArr.includes('HEALTH_ISSUE_KIDNEY');
		const hasHepaticIssue = Array.isArray(healthIssuesArr) && healthIssuesArr.includes('HEALTH_ISSUE_LIVER_DISEASE');

		visibleProducts.forEach(card => {
			const productHandle = card.dataset.productHandle;
			const quantityControls = card.querySelector('.recipe-quantity-controls');
			const plusMinusButtons = card.querySelectorAll('.button--minus, .button--plus');
			const portionInput = card.querySelector('.recipe-portion-input');
			const portionDisplay = card.querySelector('.recipe-portion-display');

			// Reset classes first
			card.classList.remove('recipe-active', 'recipe-selectable', 'recipe-disabled', 'recipe-renal', 'recipe-hepatic', 'recipe-inactive');

			// Check if product is inactive (sold out via tag)
			const isInactive = card.dataset.active === 'false';
			if (isInactive) {
				card.classList.add('recipe-inactive');
				if (quantityControls) quantityControls.style.display = 'none';
				// Ensure inactive products are not in active handles
				const inactiveIndex = this.activeRecipeHandles.indexOf(productHandle);
				if (inactiveIndex > -1) {
					this.activeRecipeHandles.splice(inactiveIndex, 1);
					delete this.recipePortions[productHandle];
				}
				return; // Skip further processing for inactive cards
			}

			// Add renal/hepatic class if applicable
			const recipeData = window.masterRecipeData[productHandle];
			if (hasRenalIssue && recipeData && recipeData.isRenal) {
				card.classList.add('recipe-renal');
			}
			if (hasHepaticIssue && recipeData && recipeData.isHepatic) {
				card.classList.add('recipe-hepatic');
			}

			if (this.activeRecipeHandles.includes(productHandle)) {
				card.classList.add('recipe-active');
				if (quantityControls) quantityControls.style.display = 'block';

				// Update portion display for active recipes
				const currentPortions = this.recipePortions[productHandle] || 0;
				if (portionInput) portionInput.value = currentPortions;
				if (portionDisplay) portionDisplay.textContent = currentPortions;

				// NEW: Control visibility of +/- buttons based on manual mode
				// For renal/hepatic recipes, never show +/- buttons since they're not adjustable
				if ((hasRenalIssue && recipeData && recipeData.isRenal) || (hasHepaticIssue && recipeData && recipeData.isHepatic)) {
					plusMinusButtons.forEach(btn => { btn.style.display = 'none'; });
				} else {
					plusMinusButtons.forEach(btn => {
						btn.style.display = this.isManualMode ? 'inline-block' : 'none';
					});
				}

			} else if (this.activeRecipeHandles.length >= this.maxRecipesAllowed && !this.isManualMode) {
				card.classList.add('recipe-disabled');
				if (quantityControls) quantityControls.style.display = 'none';
				plusMinusButtons.forEach(btn => { btn.style.display = 'none'; });
			} else {
				card.classList.add('recipe-selectable');
				if (quantityControls) quantityControls.style.display = 'none';
				plusMinusButtons.forEach(btn => { btn.style.display = 'none'; });
			}
		});
	}

	handleRecipeCardClick(event) {
		const clickedCard = event.currentTarget; // The .a-product element
		const productHandle = clickedCard.dataset.productHandle;

		// Prevent card click logic if click is on quantity controls
		if (event.target.closest('.recipe-quantity-controls')) {
			// console.log("Click on quantity controls, preventing card toggle.");
			return;
		}

		// Check if the product is inactive (sold out) - prevent selection
		if (clickedCard.dataset.active === 'false' || clickedCard.classList.contains('recipe-inactive')) {
			console.log("Product is inactive/sold out, cannot select:", productHandle);
			return;
		}

		// Check if we're in a renal or hepatic case - if so, prevent recipe deactivation
		const healthIssuesForClick = this.data_read(['_typeOfHealthIssues'])[0];
		const hasRenalIssue = Array.isArray(healthIssuesForClick) && healthIssuesForClick.includes('HEALTH_ISSUE_KIDNEY');
		const hasHepaticIssue = Array.isArray(healthIssuesForClick) && healthIssuesForClick.includes('HEALTH_ISSUE_LIVER_DISEASE');

		if (hasRenalIssue || hasHepaticIssue) {
			// console.log("Renal/hepatic case detected - recipe changes not allowed");
			return;
		}

		const wasInManualMode = this.isManualMode;

		// If a disabled card is clicked, we only proceed if we were in manual mode.
		// This allows the click to act as a trigger to exit manual mode.
		if (clickedCard.classList.contains('recipe-disabled') && !wasInManualMode) {
			console.log("Clicked disabled card, ignoring.");
			return;
		}

		// console.log("Card clicked:", productHandle);

		if (!productHandle) return;

		const index = this.activeRecipeHandles.indexOf(productHandle);

		if (index > -1) { // Recipe is currently active, so deactivate it
			this.activeRecipeHandles.splice(index, 1);
			// console.log("Deactivated:", productHandle, "Active now:", this.activeRecipeHandles);
		} else { // Recipe is not active, try to activate it
			if (this.activeRecipeHandles.length < this.maxRecipesAllowed) {
				this.activeRecipeHandles.push(productHandle);
				// console.log("Activated:", productHandle, "Active now:", this.activeRecipeHandles);
			} else {
				// If we're already at max recipes, do nothing to the recipe list.
				// The click will still serve to exit manual mode if applicable.
				// console.log("Max recipes already selected. Cannot activate:", productHandle);
			}
		}

		// If we were in manual mode, toggling back to automatic will handle redistribution and UI updates.
		// Otherwise, trigger them manually.
		if (wasInManualMode) {
			this.toggleManualMode(false);
		} else {
			this.redistributePortionsAndUpdateDisplay();
			this.renderRecipeCardsState();
		}

		// Show/hide manual mode toggle based on the new number of active recipes
		if (this.customPortionControls) {
			if (this.activeRecipeHandles.length > 1) {
				this.customPortionControls.classList.remove('is-hidden');
			} else {
				this.customPortionControls.classList.add('is-hidden');
				// This is a safeguard. If we drop to 1 or 0 recipes, manual mode should be off.
				// It would have been turned off by toggleManualMode(false) if we came from manual mode.
				if (this.isManualMode) {
					this.toggleManualMode(false);
				}
			}
		}

		// Show/hide preCheckoutPanel and checkoutPanel based on whether any recipes are active
		if (this.activeRecipeHandles.length > 0) {
			this.panels_toggle([
				[this.preCheckoutPanel, true],
				[this.checkoutPanel, true]
			]);
		} else {
			this.panels_toggle([
				[this.preCheckoutPanel, false],
				[this.checkoutPanel, false]
			]);
			this.calculateAndUpdateOverallTotal(); // Ensure totals are zero if no recipes are active
		}
	}

	add_totalTotal_MutationObserver() {
			
		let options = { attributes: true };         
		let temp = []
	
		let callback = (mutationList, observer) => {
			for (const mutation of mutationList) {
				if (mutation.type === 'attributes') {
					temp.push(mutation.target) 

					let recipe_total = Number(document.querySelector('.finalTotal').dataset.recipe_total);
					let extras_total = Number(document.querySelector('.finalTotal').dataset.extras_total);           
					let total = (recipe_total + extras_total) / 100;
					document.querySelector('.finalTotal .label_combined_total').textContent = `${new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(total)}`;                      
				}              
			}
		};

		let buldMutationObserver = new MutationObserver(callback);
		buldMutationObserver.observe(document.querySelector('.finalTotal'), options);

	}

	redistributePortionsAndUpdateDisplay() {
		// console.log("Redistributing portions. Active recipes:", this.activeRecipeHandles, "Total required portions:", this.totalRequiredPortions);

		// Zero out portions for any recipe that was active but is no longer
		const previousActiveHandles = Object.keys(this.recipePortions).filter(handle => this.recipePortions[handle] > 0);
		previousActiveHandles.forEach(handle => {
			if (!this.activeRecipeHandles.includes(handle)) {
				// console.log(`Deactivating and zeroing portions for ${handle}`);
				const card = this.querySelector(`.a-product[data-product-handle="${handle}"]`);
				if (card) {
					const portionInput = card.querySelector('.recipe-portion-input');
					const portionDisplay = card.querySelector('.recipe-portion-display');
					if (portionInput) portionInput.value = 0;
					if (portionDisplay) portionDisplay.textContent = '0';
				}
				// this.recipePortions[handle] = 0; // Will be set to 0 by updatePortionAndPrice if it was active
				this.updatePortionAndPrice(handle, 0); // This will also update overall total
			}
		});

		const N = this.activeRecipeHandles.length;

		if (N === 0) {
			// console.log("No active recipes. Ensuring totals are zero.");
			this.calculateAndUpdateOverallTotal();
			return;
		}

		const durationKey = this.periodicityValue; // "1", "2", or "4"
		const numActiveRecipesKey = String(N);
		const activeRecipeTypes = this.activeRecipeHandles.map(handle => this.getRecipeType(handle)).filter(type => type !== null);
		
		// Create a consistent key for the combination (e.g., BeefChicken, not ChickenBeef)
		const combinationKey = activeRecipeTypes.sort().join('');

		let distributionRule = null;
		if (this.portionDistributionMatrix[durationKey] && 
			this.portionDistributionMatrix[durationKey][numActiveRecipesKey] &&
			this.portionDistributionMatrix[durationKey][numActiveRecipesKey][combinationKey]) {
			distributionRule = this.portionDistributionMatrix[durationKey][numActiveRecipesKey][combinationKey];
			console.log(`Found distribution rule for ${durationKey} weeks, ${N} recipes (${combinationKey}):`, distributionRule);
		}

		if (distributionRule) {
			let totalPortionsAssignedByRule = 0;
			this.activeRecipeHandles.forEach(productHandle => {
				const recipeType = this.getRecipeType(productHandle);
				let assignedPortions = 0; // Default to 0 if not in rule
				if (recipeType && distributionRule[recipeType] !== undefined) {
					assignedPortions = distributionRule[recipeType];
					totalPortionsAssignedByRule += assignedPortions;
				} else {
					console.warn(`Recipe type ${recipeType} (for ${productHandle}) not found in distribution rule for combination ${combinationKey}. Assigning 0 portions.`);
				}

				console.log(`Matrix: Assigning ${assignedPortions} to ${productHandle} (Type: ${recipeType})`);
				const card = this.querySelector(`.a-product[data-product-handle="${productHandle}"]`);
				if (card) {
					const portionInput = card.querySelector('.recipe-portion-input');
					const portionDisplay = card.querySelector('.recipe-portion-display');
					if (portionInput) portionInput.value = assignedPortions;
					if (portionDisplay) portionDisplay.textContent = assignedPortions;
				}
				// this.recipePortions[productHandle] = assignedPortions; // updatePortionAndPrice will set this
				this.updatePortionAndPrice(productHandle, assignedPortions);
			});

			// Sanity check: if rule's total doesn't match totalRequiredPortions, log warning but proceed.
			if (totalPortionsAssignedByRule !== this.totalRequiredPortions) {
				console.warn(`Distribution rule for ${combinationKey} assigns ${totalPortionsAssignedByRule} portions, but ${this.totalRequiredPortions} are required. The matrix might need adjustment.`);
			}

		} else {
			console.warn(`No specific distribution rule found for ${durationKey} weeks, ${N} recipes, combination '${combinationKey}'. Using fallback (floor/remainder) logic.`);
			const portionsToDistribute = this.totalRequiredPortions;
			const basePortions = Math.floor(portionsToDistribute / N);
			let remainderPortions = portionsToDistribute % N;

			// console.log(`Fallback: Distributing ${portionsToDistribute} portions among ${N} recipes. Base: ${basePortions}, Remainder: ${remainderPortions}`);

			this.activeRecipeHandles.forEach((productHandle, index) => {
				let assignedPortions = basePortions;
				if (remainderPortions > 0) {
					assignedPortions++;
					remainderPortions--;
				}

				// console.log(`Fallback: Assigning ${assignedPortions} to ${productHandle}`);
				const card = this.querySelector(`.a-product[data-product-handle="${productHandle}"]`);
				if (card) {
					const portionInput = card.querySelector('.recipe-portion-input');
					const portionDisplay = card.querySelector('.recipe-portion-display');
					if (portionInput) portionInput.value = assignedPortions;
					if (portionDisplay) portionDisplay.textContent = assignedPortions;
				}
				// this.recipePortions[productHandle] = assignedPortions; // updatePortionAndPrice will set this
				this.updatePortionAndPrice(productHandle, assignedPortions);
			});
		}

		// Ensure any recipe that might have been active but isn't part of the current active set OR
		// wasn't covered by the matrix rule (and we want to explicitly zero it) is handled.
		// The initial loop at the top handles recipes that *were* active and are *no longer* active.
		// If a recipe is *still* active but a matrix rule didn't assign it portions (e.g. rule was incomplete for its type),
		// it would have been assigned 0 by the matrix logic block.

		this.calculateAndUpdateOverallTotal();
	}

	getRecipeType(productHandle) {
		const card = this.querySelector(`.a-product[data-product-handle="${productHandle}"]`);
		if (card) {
			const meatType = card.dataset.meat; // e.g., "CHICKEN"
			if (meatType) {
				// Convert to Title Case (e.g., "CHICKEN" -> "Chicken")
				return meatType.charAt(0).toUpperCase() + meatType.slice(1).toLowerCase();
			}
		}
		console.warn(`Could not determine recipe type for handle: ${productHandle}`);
		return null; // Or a default/error value
	}

	toggleManualMode(forceState = null, skipRedistribution = false) {
		// Check if we're in a renal case - if so, prevent manual mode
		const hasRenalIssue = Array.isArray(this.data_read(['_typeOfHealthIssues'])[0]) && 
							  this.data_read(['_typeOfHealthIssues'])[0].includes('HEALTH_ISSUE_KIDNEY');
		
		if (hasRenalIssue) {
			// console.log("Renal case detected - manual mode not allowed");
			// Ensure the toggle is set to false and return early
			if (this.manualModeToggle) {
				this.manualModeToggle.checked = false;
			}
			this.isManualMode = false;
			return;
		}

		const isChecked = this.manualModeToggle.checked;
		this.isManualMode = forceState !== null ? forceState : isChecked;

		// Sync checkbox state if forceState was used
		if (forceState !== null && forceState !== isChecked) {
			this.manualModeToggle.checked = forceState;
		}
		
		if (this.isManualMode) {
			// Switched TO manual mode
			this.manualModeStatus.style.display = 'block';
			this.checkManualTotalAndToggleATC(); // Initial check
		} else {
			// Switched TO automatic mode
			this.manualModeStatus.style.display = 'none';
			
			// Re-enable ATC because auto mode always has correct totals
			this.validation_toggleStepBtn(true, this.atc); 
	
			// Re-balance portions only if not skipped (e.g., during plan type changes)
			if (!skipRedistribution) {
				this.redistributePortionsAndUpdateDisplay();
			}
		}
		
		// ALWAYS re-render card state after toggling mode to show/hide buttons
		this.renderRecipeCardsState();
	}
	
	checkManualTotalAndToggleATC() {
		if (!this.isManualMode) return;
	
		let currentTotal = Object.values(this.recipePortions).reduce((sum, portions) => sum + (portions || 0), 0);
	
		// Update the numbers in the spans
		const statusDiv = this.manualModeStatus;
		if (statusDiv) {
			const currentSpan = statusDiv.querySelector('.manual-mode-current');
			const totalSpan = statusDiv.querySelector('.manual-mode-total');
			if (currentSpan) currentSpan.innerText = currentTotal;
			if (totalSpan) totalSpan.innerText = this.totalRequiredPortions;
		}
	
		if (currentTotal === this.totalRequiredPortions) {
			this.validation_toggleStepBtn(true, this.atc);
			this.manualModeStatus.style.color = 'green'; // Simple styling
			// Show checkout panels if they are hidden and recipes are active
			if(this.activeRecipeHandles.length > 0) {
				this.panels_toggle([ [this.preCheckoutPanel, true], [this.checkoutPanel, true] ]);
			}
		} else {
			this.validation_toggleStepBtn(false, this.atc);
			this.manualModeStatus.style.color = 'red'; // Simple styling
		}

		// Disable/enable plus buttons based on the total
		this.activeRecipeHandles.forEach(handle => {
			const card = this.querySelector(`.a-product[data-product-handle="${handle}"]`);
			if (card) {
				const plusButton = card.querySelector('.button--plus');
				if (plusButton) {
					plusButton.disabled = (currentTotal >= this.totalRequiredPortions);
				}
			}
		});
	}

}
customElements.define('food-planner-wizard', FoodPlannerWizard);


/*
	Sets up a MutationObserver to monitor changes to the aria-selected attribute of the tabs.
	When a tab is selected (aria-selected="true"), it triggers a custom tracking event.	
*/
function fbEvents() {

	const targetNodes = document.querySelectorAll(".aTab");
	const config = { attributes: true };
	const callback = (mutationList, observer) => {
		for (const mutation of mutationList) {
			if (mutation.type === "attributes" && mutation.attributeName == 'aria-selected' && mutation.target.getAttribute('aria-selected') == 'true') {
				fbq('trackCustom', 'TabSelected', { tab_id: `${mutation.target.id}` });
			}
		}
	};

	const observer = new MutationObserver(callback);
	targetNodes.forEach(targetNode => {
		observer.observe(targetNode, config);
	})

}


/*
	When the window loads, immediately trigger a custom tracking event for tab1.
	Then call the fbEvents() function to set up the MutationObserver for further tracking events.
*/
// window.addEventListener('load', ()=> {
// 	fbq('trackCustom', 'TabSelected', { tab_id: 'tab1' });
// 	fbEvents()
// })